'use strict';

exports.default = exports;

const FcmModel = require('./model/FcmModel');
const NumberUtils = require('./NumberUtils');
const ObjectUtils = require('./ObjectUtils');
const dataConvert = require('./dataConvert');
const DeepObjectDiff = require('deep-object-diff');
const DateUtils = require('./DateUtils');
const {PorteAnestesico2Porte, BillingActions, TransactionType, TeamTypes, GroupPerHourType, PackageType, Accommodation, CustomProportionType} = require('./status');
const InsuranceDefault = require('./data/InsuranceDefault');
const status = require('./status');
const {createProcedureTeamContext} = require('./ProcedureTeamContext');
const {isPerProcedureTeamEnabled} = require('./data/InsuranceHelpers');
const moment = require('moment');
const EventStatus = status.EventStatus;
const ProcedureType = status.ProcedureType;
const _ = require('lodash');
const {deburr} = require('@common/StringUtils');

const ActionsOnFinishEvent = status.ActionsOnFinishEvent;
const typesThatAreNotProcedureInTransaction = {
  [TransactionType.COMPLEMENTATION]: true,
  [TransactionType.ATTENDANCEFEE]: true,
  [TransactionType.EXPENSE]: true,
};

/**
 *
 * @type firebase.app.App
 */
let firebase = null;
function startFirebase() {
  if(!firebase) {
    // eslint-disable-next-line
    if(typeof window!=='undefined') { // Verificando se está na web
      // eslint-disable-next-line
      firebase = window.firebaseInjectCommon;
    }
    else {
      firebase = require('firebase-admin');
    }
    if(firebase.default) {
      firebase = firebase.default;
    }
  }
}

const MANDATORY_FIELDS_CACHE_TTL_MS = 60000;
const mandatoryFieldsCache = new Map();

/**
 * Documento de campos obrigatórios, com deduplicação de leitura.
 *
 * A validação de evento chama isto uma vez por evento, e a importação de
 * planilha valida a seleção inteira: uma planilha de 2500 linhas virava 2500
 * leituras do Firestore disparadas juntas, quase todas do mesmo documento. Além
 * de travar a tela, isso alargava para minutos a janela em que duas validações
 * do mesmo evento se atropelam.
 *
 * Duas camadas: chamadas simultâneas compartilham a mesma promise, e o
 * resultado fica em cache por um tempo curto. O TTL é curto de propósito —
 * mandatoryFields é configuração, muda raramente, e um minuto de defasagem
 * custa menos que a rajada de leituras. Falha não entra em cache.
 *
 * @param {string} mandatoryFieldsId
 * @returns {Promise<object|null>}
 */
async function getMandatoryFieldsDoc(mandatoryFieldsId) {
  startFirebase();

  const cached = mandatoryFieldsCache.get(mandatoryFieldsId);
  if(cached?.promise) {
    return cached.promise;
  }
  if(cached && (Date.now() - cached.at) < MANDATORY_FIELDS_CACHE_TTL_MS) {
    return cached.doc;
  }

  const promise = firebase.firestore().collection('mandatoryFields').doc(mandatoryFieldsId).fcmGet();
  mandatoryFieldsCache.set(mandatoryFieldsId, {promise});
  try {
    const doc = await promise;
    mandatoryFieldsCache.set(mandatoryFieldsId, {doc, at: Date.now()});
    return doc;
  }
  catch (err) {
    mandatoryFieldsCache.delete(mandatoryFieldsId);
    throw err;
  }
}
exports.getMandatoryFieldsDoc = getMandatoryFieldsDoc;

/**
 * Limpa o cache de campos obrigatórios. Existe para os testes e para quem
 * grava o documento e precisa ler o valor novo sem esperar o TTL.
 */
exports.clearMandatoryFieldsCache = function() {
  mandatoryFieldsCache.clear();
};

let FinancialRepositoryGQL = null;
let TransactionEntity = null;
exports.initClient = function(_FinancialRepositoryGQL, _TransactionEntity) {
  FinancialRepositoryGQL = _FinancialRepositoryGQL;
  TransactionEntity = _TransactionEntity;
};


/*
let teste = {
  complementation: 0,
  complementationReceived: 0,
  totalGlosado: 0,
  totalProcedures: 0,
  totalProceduresReceived: 0,
  totalProduced: 0,
  totalReceived: 0,
  totalOver: 0,
  totalInProcessing: 0,
  totalLoss: 0,
  complementationLoss: 0,
}



let t2 = {
  totalReceived: 0,
  totalGlosado: 0,
  value: 0,
  totalLoss: 0,
  totalOver: 0,
}


\.valor([\s\);><\(]) -> .value$1
\.valor_perca([\s\);><\(]) -> .totalLoss$1
\.total_recebido([\s\);><\(]) -> .totalReceived$1
\.valor_glosa([\s\);><\(]) -> .totalGlosado$1


*/

exports.updateEventSimple = async function(event) {
  startFirebase();
  // console.log('Fcm', event);
  if(!event.id) {
    console.error('updateEvent: event.id não encontrado');
    return null;
  }
  if(event.healthInsurance) {
    event.healthInsurance = dataConvert.healthInsuranceResume(event.healthInsurance);
  }
  try {
    await firebase.firestore().collection('events').doc(event.id).set(event, {merge: true});
    return true;
  } catch (err) {
    console.error('updateEvent: Erro ao salvar evento', err);
    return null;
  }
};

exports.getTransactions = async function(eventId) {
  if(!FinancialRepositoryGQL) {
    console.error('FinancialRepositoryGQL não inicializado, essa função não funciona nas cloud functions');
    throw new Error('FinancialRepositoryGQL não inicializado, essa função não funciona nas cloud functions');
  }
  return FinancialRepositoryGQL.getTransactionsByEventId(eventId);

  //
  // startFirebase();
  // return (await firebase.firestore().collection('transactions')
  //   .where('eventId', '==', eventId)
  //   .get()
  // ).docs.map(
  //   (a)=>{
  //     const el = a.data();
  //     el.id = a.id;
  //     return el;
  //   });
};

exports.saveTransactions = async function(trs) {
  if(!FinancialRepositoryGQL) {
    console.error('FinancialRepositoryGQL não inicializado, essa função não funciona nas cloud functions');
    throw new Error('FinancialRepositoryGQL não inicializado, essa função não funciona nas cloud functions');
  }
  // Já é salvo também no firebase no FinancialRepositoryGQL.saveTransactions
  // const b = firebase.firestore().batch();
  // for(let tr of trs) {
  //   let tmp = tr;
  //   if(typeof tmp.toFirestore === 'function') {
  //     tmp = tmp.toFirestore();
  //   }
  //   b.set(firebase.firestore().collection('transactions').doc(tr.id), tmp, {merge: true});
  // }

  await FinancialRepositoryGQL.saveTransactions(trs.map(a=>new TransactionEntity(a)));
//  await b.commit();
};

/**
 * O lote como ele deve viver **dentro do evento**: um resumo de quatro campos.
 *
 * O documento de `batches` carrega competência, convênio, tipo, contadores,
 * marcadores de retroatividade e a auditoria inteira. Nada disso pertence ao
 * evento: o evento guarda o `batchesIds` para a relação e este resumo para
 * exibir código e nome sem uma segunda leitura. Copiar o documento todo grava
 * dezenas de campos por evento que envelhecem sozinhos — o `countEvents` e o
 * `status` do lote mudam depois, e a cópia no evento fica mentindo.
 *
 * É a forma que `clearEvent` já aplicava ao gravar pela tela, e é por isso que o
 * mesmo evento tinha um lote enxuto quando salvo pelo EventEdit e um lote
 * inteiro quando o autoBatch o vinculava.
 *
 * @param {object} batch documento do lote
 * @returns {{active: boolean, code: string, id: string, name: string}}
 */
exports.batchResume = function(batch) {
  return {
    active: batch?.active || false,
    code: batch?.code || '',
    id: batch?.id || '',
    name: batch?.name || '',
  };
};

/**
 * Resumo do lote que a COBRANÇA guarda em `cobranca.batch`.
 *
 * Mesma ideia do `batchResume` do evento, com os campos que as telas de cobrança
 * leem (`Cobrancas.vue`, `PickerCobrancas`, `EditEventValuesCobranca`, relatório
 * de baixadas, `ResumeBuilder`): código, nome, tipo, status, data, convênio por
 * id e nome, contagem de eventos. Nunca `healthInsurance` — o `addCobranca`
 * clonava o form inteiro do lote, hidratado com o documento do convênio
 * (negociações, tabelas, XML…), e cada cobrança nascia com até 266 KB de
 * convênio dentro (#1245). O `beforeSave` do lote já saneava o próprio lote;
 * a cópia na cobrança não passava pelo mesmo tratamento.
 *
 * `healthInsuranceId`/`healthInsuranceName` saem do campo plano quando existe e,
 * senão, do objeto embutido — o form do lote na tela só tem o objeto até o
 * `beforeSave` derivar os campos planos.
 *
 * @param {object} batch documento ou form do lote
 * @returns {object} resumo, sem `healthInsurance`, `company`, `attachments`, `meta`
 */
exports.batchResumeForCobranca = function(batch) {
  return {
    id: batch?.id || '',
    code: batch?.code || '',
    sequencialTransacao: batch?.sequencialTransacao || '',
    name: batch?.name || '',
    type: batch?.type || '',
    status: batch?.status || '',
    date: batch?.date || null,
    dateIso: batch?.dateIso || null,
    dateIsoYearMonth: batch?.dateIsoYearMonth || null,
    healthInsuranceId: batch?.healthInsuranceId || batch?.healthInsurance?.id || null,
    healthInsuranceName: batch?.healthInsuranceName || batch?.healthInsurance?.name || '',
    countEvents: batch?.countEvents || 0,
  };
};

exports.clearEvent = function(event) {
  for (const i in event.attachments || {}) {
    delete event.attachments[i]?._tmp;
  }
  delete event.healthInsurance;
  // Resumos {name} que o attachResumeToEvent pendura para a tela
  delete event.hospital;
  delete event.surgeon;
  delete event.anesthetist;
  delete event.secondaryAnesthetist;
  delete event.thirdAnesthetist;
  delete event.resident;
  delete event.phonoaudiologist;
  delete event.requester;
  delete event.overrideExecutant;
  delete event.company;
  if (event.patient) {
    delete event.patient.meta;
  }
  for (const b in event.batches || {}) {
    event.batches[b] = exports.batchResume(event.batches[b]);
  }
};

/**
 * Tipo da empresa que está criando o evento, para `meta.createdByCompanyType`:
 * matriz (cooperativa), filial (cooperado) ou produção pessoal. Toda criação de
 * evento — tela e importação — grava por esta regra, porque é por esse campo que
 * o lote automático seletivo (`autoBatchAfterCheckFilialOnly`) sabe quem lançou o
 * evento (#1232). Retorna null quando a empresa não é nenhum dos três; nesse
 * caso o campo não é gravado.
 * @param {object} company empresa logada (currentCompany)
 * @returns {string|null} um de status.CreatedByCompanyType, ou null
 */
exports.getCreatedByCompanyType = function(company) {
  if (company?.isMatriz) {
    return status.CreatedByCompanyType.KMATRIZ;
  }
  if (company?.isFilial) {
    return status.CreatedByCompanyType.KFILIAL;
  }
  // O CompanyEdit grava a produção pessoal em flags; a raiz é legado.
  if (company?.isPersonalProduction || company?.flags?.isPersonalProduction) {
    return status.CreatedByCompanyType.KPERSONALPRODUCTION;
  }
  return null;
};

exports.updateEvent = async function(event, updateInfo, resume = false, trs) {
  startFirebase();
  if(!event.id) {
    console.error('updateEvent: event.id não encontrado');
    return null;
  }
  try {
    let ret = null;
    if(resume) {
      ret = {
        active: event.active || false,
        status: event.status || {},
        additionalData: event.additionalData || {},
        values: event.values || {},
        batches: event.batches || [],
        batchesIds: event.batchesIds || [],
        procedures: event.procedures || [],
        multAdditionalData: event.multAdditionalData || [],
        observations: event.observations || [],
      };
    }
    else {
      ret = FcmModel.getUpdateObj('events', event);
      if(!ret) {
        console.error('getUpdateObj');
        return;
      }
    }

    exports.clearEvent(ret);
    if(trs?.length) {
      const pUpdate = firebase.firestore().collection('events').doc(event.id).set({
        ...ret,
        ...updateInfo,
      }, {merge: true});

      for (const tr of trs || []) { await checkCobrancaIdInTransaction(tr); }
      await exports.saveTransactions(trs);
      await pUpdate;
    } else {
      await firebase.firestore().collection('events').doc(event.id).set({
        ...ret,
        ...updateInfo,
      }, {merge: true});
    }
    return true;
  } catch (err) {
    console.error('updateEvent: Erro ao salvar evento', err);
    return null;
  }
};
exports.valueChanged = function(procedure) {
  procedure.value = NumberUtils.currency(procedure.valueOriginal + (procedure.valueChanged || 0));
  return procedure;
};

const typesComplemmentationAndAttendanceFee = {
  [TransactionType.COMPLEMENTATION]: true,
  [TransactionType.ATTENDANCEFEE]: true,
};

async function checkCobrancaIdInTransaction(transaction) {
  if(transaction.cobrancaId || !(transaction.batchesIds?.length > 0)) { return transaction; }

  startFirebase();
  const batchId = transaction.batchesIds?.[0];
  const batch = await firebase.firestore().collection('batches').doc(batchId).fcmGet() || null;

  if (batch && batch.cobrancas?.length > 0) { transaction.setFcm({cobrancaId: batch.cobrancas[0] || null}); }

  return transaction;
}
exports.checkCobrancaIdInTransaction = checkCobrancaIdInTransaction;

function newId(collection) {
  startFirebase();
  return firebase.firestore().collection(String(collection || 'newId')).doc().id;
}

/**
 * Tem uma gambiarra aqui que se você for utilizar precisa saber.
 * A empresa é adicionada no evento para que aqui a função saiba se é uma empresa médica ou não.
*/
function createTransaction(event, pr = {}, value, action, userInfo, isAutoFix=false) {
  const actor = getMainActorInEvent(event);
  return new TransactionEntity({
    value: value,
    id: newId(),
    userId: userInfo?.userId || 'autoFix',
    userName: userInfo?.userName || 'Auto Fix',
    action: action,
    date: new Date(),
    creationDate: new Date(),
    autoFix: isAutoFix,
    appealId: pr?.appealId || null,
    batchId: pr?.batchId || null,
    cobrancaId: pr?.cobrancaId || event.cobrancaId || null,
    procedureRowId: (pr?.rowId==='additional' || pr?.rowId==='attendanceFee') ? null : (pr?.rowId || null),
    procedureTeamId: isPerProcedureTeamEnabled(event) ? (pr?.procedureTeamId ?? null) : null,
    rowIdAdditionalData: pr?.rowIdAdditionalData || null,
    paid: false,
    canceledId: null,
    canceledById: null,
    transferId: null,
    isAdditional: false,
    type: typesThatAreNotProcedureInTransaction[pr.type] ? pr.type : TransactionType.PROCEDURE,
    eventId: event.id,
    companyId: event.companyId || null,
    matrizId: event.matrizId || null,
    isMatriz: event.isMatriz || false,
    healthInsuranceId: event.healthInsuranceId || null,
    batchesIds: event.batchesIds || null,
    receiverId: actor?.id || null,
    receiverType: actor?.type || null,
    hospitalId: event.hospitalId || null,
    dtProcedure: event.dtProcedure || null,

    financialItemId: event.financialItemId || null
  });
}
exports.createTransaction = createTransaction;

function getMainActorInEvent(event) {
  const isMedical = event.company?.billingType === status.CompanyBillingType.MEDICAL;
  if (event.actors?.length) {
    if (isMedical) {
      return event.actors.find(a => (a.type === TeamTypes.KSURGEON || a.type === TeamTypes.KPHONOAUDIOLOGIST) && a.id);
    }

    return event.actors.find(a => a.type === TeamTypes.KANESTHETIST);
  }

  return {
    type: isMedical ? TeamTypes.KSURGEON : TeamTypes.KANESTHETIST,
    id: isMedical ? event.surgeonId : event.anesthetistId,
  };
}
exports.getMainActorInEvent = getMainActorInEvent;

function _fixTransactionPr(event, trs, pr, field, action, userInfo, isAutoFix=false, extraActions = null) {
  const value = NumberUtils.currency(pr[field] - trs?.filter((a) => a.eventId === event.id &&
    (a.procedureRowId === pr.rowId || (typesComplemmentationAndAttendanceFee[pr.type] && pr.type === a.type)) &&
    (a.action === action || extraActions?.includes?.(a.action)))
    .reduce((p, v)=>p+(v.value||0),0));
  if(value) {
    trs.push(createTransaction(event, pr, value, action, userInfo, isAutoFix));
  }
}

function _checkIfNeedTransactionPr(event, trs, pr, field, action) {
  return Math.abs(NumberUtils.currency(pr[field] - trs?.filter((a) => a.eventId===event.id &&
    (a.procedureRowId === pr.rowId || (typesComplemmentationAndAttendanceFee[pr.type] && pr.type === a.type)) &&
    a.action === action)
    .reduce((p, v)=>p+(v.value||0),0)));
}

/**
 * @param event
 * @param trs
 * @returns
 */
exports.checkIfNeedFix = function(event, trs) {
  // if(!event.transactions) { event.transactions = []; } Não parece necessário mais
  let sum = 0;
  const eventTmp = setAuxItemsInProcedures(_.cloneDeep(event));
  for(const pr of eventTmp.procedures || []) {
    sum += _checkIfNeedTransactionPr(eventTmp, trs, pr, 'totalReceived', BillingActions.Received) +
    _checkIfNeedTransactionPr(eventTmp, trs, pr, 'totalLoss', BillingActions.Losed) +
    _checkIfNeedTransactionPr(eventTmp, trs, pr, 'totalGlosado', BillingActions.Glosado) +
    _checkIfNeedTransactionPr(eventTmp, trs, pr, 'totalDiscount', BillingActions.Discounted);
  }

  return NumberUtils.currency(sum);
};

/**
 * Útil para adicionar transações para valores recebidos antes das transações existirem
 * @param event
 * @param trs
 * @param userInfo
 * @param isAutoFix
 * @returns
 */
function fixMissingTransaction(event, trs, userInfo, isAutoFix) {
  if(!trs) {
    console.error('tr is empty');
    return;
  }

  const eventTmp = setAuxItemsInProcedures(_.cloneDeep(event));

  for(const pr of eventTmp.procedures || []) {
    _fixTransactionPr(eventTmp, trs, pr, 'totalReceived', BillingActions.Received, userInfo, isAutoFix,
      [BillingActions.ReceivedToOver, BillingActions.ReceivedFromOver]);
    _fixTransactionPr(eventTmp, trs, pr, 'totalLoss', BillingActions.Losed, userInfo, isAutoFix);
    _fixTransactionPr(eventTmp, trs, pr, 'totalGlosado', BillingActions.Glosado, userInfo, isAutoFix);
    _fixTransactionPr(eventTmp, trs, pr, 'totalDiscount', BillingActions.Discounted, userInfo, isAutoFix);
  }
}
exports.fixMissingTransaction = fixMissingTransaction;

/**
 *
 * @param {any} event
 * @param {boolean} add_reasons adiciona o campo _reasons para adicionar os motivos de glosa.
 * @param {boolean = false} insertNewId adiciona um novo id na complementação e no co-participativo.
 * @return any
 */
function setAuxItemsInProcedures(event, add_reasons=false, insertNewId = false) {
  const additionalDataMulti = event.multAdditionalData || (event.additionalData ? [event.additionalData] : null) || [];
  for (const additionalData of additionalDataMulti) {
    for (const expense of additionalData.otherExpenses || []) {
      const proc = {
        ...expense,
        value: expense.totalValue,
        rowId: expense.rowId || newId(),
        rowIdAdditionalData: additionalData.rowId || null,
        type: TransactionType.EXPENSE,
        idProc: expense.itemCode,
        name: expense.description,
      };
      add_reasons && (proc._reasons = []);
      event.procedures.push(proc);
    }
  }
  const values = event?.values || {};
  if(values.complementation) {
    const complementation = {
      rowId: insertNewId ? newId() : 'additional',
      name: 'Valor adicional',
      value: values.complementation || 0,
      totalLoss: values.complementationLoss || 0,
      totalReceived: values.complementationReceived || 0,
      totalDiscount: values.complementationDiscount || 0,
      totalGlosado: values.complementationGlosado || 0,
      type: TransactionType.COMPLEMENTATION,
    };
    add_reasons && (complementation._reasons = []);
    event.procedures.push(complementation);
  }

  if(values.attendanceFee) {
    const attendanceFee = {
      rowId: insertNewId ? newId() : 'attendanceFee',
      name: 'Co-participativo',
      value: values.attendanceFee || 0,
      totalLoss: values.attendanceFeeLoss || 0,
      totalReceived: values.attendanceFeeReceived || 0,
      totalDiscount: values.attendanceFeeDiscount || 0,
      totalGlosado: values.attendanceFeeGlosado || 0,
      type: TransactionType.ATTENDANCEFEE,
    };
    add_reasons && (attendanceFee._reasons = []);
    event.procedures.push(attendanceFee);
  }

  return event;
}
exports.setAuxItemsInProcedures = setAuxItemsInProcedures;

function getValueInTransactions(event, type, action, nameValue, transactions) {
  return NumberUtils.currency((event.values[nameValue] || 0) -
    transactions?.filter((a)=>a.eventId===event.id && a.type === type && a.action === action)
      .reduce((p, v)=>p+(v.value||0),0));
}
exports.getValueInTransactions = getValueInTransactions;


exports.getAdditionalToEdit = function(event, index, healthInsurance, onlyHourOnEventBeginEnd=false, _anesthesiaStart=null, _anesthesiaEnd=null, company=null) {
  startFirebase();
  const additionalData = event.multAdditionalData?.[index] || {};
  const fieldsDefaultXML = healthInsurance?.fieldsDefaultXML || {};
  const companyFlags = company.flags || null;
  // console.log('info.data', info.data);

  additionalData.anesthesiaStart ||= event.anesthesiaStart || event.dtProcedure || null;
  additionalData.anesthesiaEnd ||= event.anesthesiaEnd || null;

  if(onlyHourOnEventBeginEnd && _anesthesiaStart) {
    let find = _anesthesiaStart?.match?.(/(.*):(.*)/);
    let dtProcedure;
    if (event.dtProcedure?.seconds > 0 || event?.dtProcedure.nanoseconds > 0) {
      dtProcedure = moment((event.dtProcedure.seconds*1000)+(event.dtProcedure.nanoseconds/10e6));
    } else if (event?.dtProcedure && !event?.dtProcedure?.isValid?.()) {
      dtProcedure = moment(event.dtProcedure);
    } else {
      dtProcedure = moment(event.dtProcedure?.toDate());
    }
    dtProcedure.set('hour', find?.length>1?find[1]:0);
    dtProcedure.set('minute', find?.length>2?find[2]:0);

    const anesthesiaStart = moment(dtProcedure);
    const anesthesiaEnd = moment(dtProcedure);

    find = _anesthesiaEnd?.match?.(/(.*):(.*)/);
    anesthesiaEnd.set('hour', find?.length>1?find[1]:0);
    anesthesiaEnd.set('minute', find?.length>2?find[2]:0);
    if(anesthesiaEnd.diff(anesthesiaStart)<0) {
      anesthesiaEnd.add(1, 'day');
    }
    additionalData.anesthesiaStart = anesthesiaStart.toDate();
    additionalData.anesthesiaEnd = anesthesiaEnd.toDate();
  }

  additionalData.rowId ||= firebase.firestore().collection('newId').doc().id;
  additionalData.name ||= 'Adicional '+(index+1);

  additionalData.numberWallet ||= event.healthInsuranceWallet || event.patient?.healthInsuranceWallet || '';

  const totalProcedures = ((additionalData.proceduresIds?.length > 0) || !(event.multAdditionalData?.length > 1) ?
    (event.procedures.filter(a => additionalData.proceduresIds?.includes(a.rowId)) || []).reduce((accumulator, currentValue) => accumulator + currentValue.value, 0) :
    event.values?.totalProcedures) || null;

  additionalData.totalFees = totalProcedures;
  additionalData.attendanceRN ||= fieldsDefaultXML.attendanceRN || status.defaultInGuide.attendanceRN;
  additionalData.accidenteIndication ||= fieldsDefaultXML.accidenteIndication || status.defaultInGuide.accidenteIndication;

  if(!additionalData.total && event.type === status.EventType.SPSADT) {
    additionalData.total = 0;
    additionalData.attendimentType ||= fieldsDefaultXML.attendimentType || status.defaultInGuide.attendimentType;
    additionalData.reasonToFinishAttendiment ||= fieldsDefaultXML.reasonToFinishAttendiment || status.defaultInGuide.reasonToFinishAttendiment;
    const totalTaxes = Number(additionalData.totalTaxes || 0);
    const totalDayly = Number(additionalData.totalDayly || 0);
    const totalMaterials = Number(additionalData.totalMaterials || 0);
    const totalDrugs = Number(additionalData.totalDrugs || 0);
    const totalOPME = Number(additionalData.totalOPME || 0);
    const totalGasesMedicinals = Number(additionalData.totalGasesMedicinals || 0);

    additionalData.total = NumberUtils.round(
      totalProcedures + totalTaxes +  totalDayly + totalMaterials + totalDrugs + totalOPME + totalGasesMedicinals
      , 2);
  }

  additionalData.startDateBilling = this.getNormalizedBillingDateField(event, healthInsurance, 'startDateBilling');
  additionalData.endDateBilling = this.getNormalizedBillingDateField(event, healthInsurance, 'endDateBilling');

  if(event.additionalData.valueProcedureConsult==='') { event.additionalData.valueProcedureConsult = 0; }

  if (event.type === status.EventType.Consulta) {
    const proc = (event.multAdditionalData?.length > 1 && additionalData.proceduresIds?.length > 0 ?
      event.procedures.find(a => a.rowId === additionalData.proceduresIds[0]) :
      event.procedures?.[0]) || {};

    additionalData.consultType = exports.resolveDefaultValue(
      additionalData.consultType,
      fieldsDefaultXML.consultType,
      status.defaultInGuide.consultType,
      '1'
    );

    if (companyFlags.notUpdateConsultProcInAdditionalData) {
      additionalData.valueProcedureConsult ||= proc.value || null;
      additionalData.codeProcedureConsult ||= proc.idProc || null;
    } else {
      additionalData.valueProcedureConsult = proc.value || null;
      additionalData.codeProcedureConsult = proc.idProc || null;
    }
    additionalData.attendanceDateConsult = event?.dtProcedure || null;
  }


  return additionalData;
};

exports.getMillis = function(date) {
  if (!date) {
    return null;
  }
  let millis = null;
  if(typeof date==='number') {
    millis = date;
  }
  else if(typeof (date || {}).getTime==='function') {
    millis = date.getTime();
  }
  else if(typeof (date || {}).toMillis==='function') {
    millis = date.toMillis();
  }
  else {
    const tmp = moment(date);
    if(tmp.isValid()) {
      millis = tmp.valueOf();
    }
  }
  return millis;
};

/**
 * Teste
  EventUtils.getNegotiationId(new Date('2021-04-25'), {negotiations: {
    teste1: {
        start: firebaseDebug.firestore.Timestamp.fromDate(new Date('2021-02-23')),
        end: firebaseDebug.firestore.Timestamp.fromDate(new Date('2021-04-23'))
    },
    teste2: {
        start: firebaseDebug.firestore.Timestamp.fromDate(new Date('2021-04-23')),
        end: firebaseDebug.firestore.Timestamp.fromDate(new Date('2021-05-10'))
    }
}});
 *
 * Obs: não funciona na InsuranceEdit, pois é utilizado _startMoment(no lugar de start) e _endMoment(no lugar de end)
 * @param date
 * @param healthInsurance
 * @returns {null|*}
 */
exports.getNegotiation = function(date, healthInsurance) {
  const getMillis = exports.getMillis;
  const millis = getMillis(date);
  for(const n of (healthInsurance||{}).negotiations || []) {
    const millisNegotiationStart = !n.start ? null : getMillis(typeof (n.start || {}).toDate==='function' ? n.start.toDate().setMilliseconds(0) : n.start);
    const millisNegotiationEnd = !n.end ? null : getMillis(typeof (n.end || {}).toDate==='function' ? n.end.toDate().setMilliseconds(999) : n.end);
    if(millis >= (millisNegotiationStart || -Infinity) && millis <= (millisNegotiationEnd || Infinity)) {
      return n;
    }
  }
  return null;
};

/**
 *
 * @param {Object} data
 * @param {Object} data.procedure - The procedure to process
 * @param {Object} data.event - The event context
 * @param {Object} data.negotiation - Optional negotiation object
 * @param {boolean} data.fixValueOriginal - Whether to fix original values
 * @param {Object} data.company - The company object
 * @returns {{useAsCBHPM}|*|null}
 */
exports.setValueProc = function(data) {
  let {
    procedure,
    event,
    negotiation = null,
    fixValueOriginal = true,
    company = null
  } = data;
  const ctx = createProcedureTeamContext(event, procedure);
  if(!negotiation) {
    negotiation = exports.getNegotiation(ctx.dtProcedure, event.healthInsurance) || null;
  }
  if(!negotiation) {
    console.error('Not found negotiation');
    return null;
  }

  // if(!company) { console.warn('Not found company in setValueProc!'); }

  const isMedical = company?.billingType === status.CompanyBillingType.MEDICAL;
  const medicalReturn = event.healthInsurance?.configs?.medicalReturn?.[event?.type] || {};

  if (event.isFollowUp && medicalReturn.setValueZero) {
    procedure.value = 0;
    procedure.valueBase = 0;
    procedure.valueChanged = 0;
    procedure.valueOriginal = 0;
    if (negotiation.enableTechniqueUsed) {
      procedure.techniqueUsed ||= status.techniquesUsed.KConventional;
    }
    procedure.userCustom = status.ProcedureUserCustom.FINAL;
    addRowId(procedure);
  } else {
    setValueProcOriginal({
      procedure: procedure,
      negotiation: negotiation,
      isMedical: isMedical,
      isParticular: event.healthInsurance?.isParticular,
      fixValueOriginal: fixValueOriginal,
      event: event,
    });
  }

  if (!event.actors?.length) { setTeamInEvent(event); }
  setTeamAndValue(procedure, negotiation, event, company, ctx);

  procedure.value = NumberUtils.currency(NumberUtils.round(procedure.value));
  procedure.valueBase = NumberUtils.currency(NumberUtils.round(procedure.valueBase));
  procedure.valueChanged = NumberUtils.currency(NumberUtils.round(procedure.valueChanged));

  setIdProcGroup(negotiation, event, procedure);

  // Retrocompatibilidade, autofix
  if (!procedure.rowId) {
    startFirebase();
    procedure.rowId = firebase.firestore().collection('procedures').doc().id;
  }
  // console.trace('Super teste', _.cloneDeep(procedure));
  return procedure;
};

function setIdProcGroup(negotiation, event, proc) {
  if (negotiation.canEditProcedureCode) {
    if((proc.type === ProcedureType.KCBHPM || proc.type === ProcedureType.KOVERRIDEPORTE) && proc.porteAnestesico > -1) {
      const _ctx = createProcedureTeamContext(event, proc);
      const _accommodation = (_ctx?.isTabMode ? (_ctx.accommodation ?? event?.accommodation) : event?.accommodation) || Accommodation.NONE;
      // Os dois primeiros já eram opcionais; o terceiro é o campo mais antigo dos
      // três e ficou sem proteção. Como é o último do encadeamento de `||`, só
      // estoura quando os outros dois não resolvem — que é justamente a negociação
      // antiga, a mesma que tem o campo null.
      proc.idProcGroupedByPort = negotiation.anestheticsProceduresCodesByAccommodation?.[_accommodation]?.[proc.porteAnestesico] || negotiation.anestheticsProceduresCodesByEventType?.[event?.type]?.[proc.porteAnestesico] || negotiation.anestheticsProceduresCodes?.[proc.porteAnestesico] || null;
      proc.search = getSearch(proc);
    }
  }
}

function setAttendanceFeeValueInProcedure(proc, event) {
  if (proc.participative > 0) {
    event.values.attendanceFee += NumberUtils.currency(proc.participative);
  }
  return event;
}
exports.setAttendanceFeeValueInProcedure = setAttendanceFeeValueInProcedure;

/**
 * Refaz a taxa de atendimento do evento a partir da co-participação dos
 * procedimentos.
 *
 * `procedures` existe porque nem sempre a lista já está no evento. Na
 * importação, `calcProceduresValues` monta os procedimentos num array local e
 * quem os atribui ao evento é o chamador, **depois** do retorno — e a maioria
 * dos chamadores ainda zera `event.procedures` antes. Lendo só do evento, a soma
 * caía sobre lista vazia e o co-participativo da planilha não chegava a
 * `values.attendanceFee`: o evento nascia com o procedimento já descontado
 * (110 − 33 = 77) e sem os 33 em lugar nenhum, então `totalProduced` ficava 77 em
 * vez de 110 e o recebimento nunca era marcado.
 *
 * @param {Object} event evento a atualizar
 * @param {Array<Object>} [procedures] lista a somar; sem ela, a do evento
 * @returns {Object} o mesmo evento
 */
function setAttendanceFeeValueFromProcedures(event, procedures = null) {
  event.values.attendanceFee = 0;
  for (const proc of procedures || event.procedures || []) {
    event.values.attendanceFee += NumberUtils.currency(proc.participative || 0);
  }
  return event;
}
exports.setAttendanceFeeValueFromProcedures = setAttendanceFeeValueFromProcedures;

function getSearch(p) {
  return deburr(`${p.idProc||''} ${p.name||''}   ${p.idProcGroupedByPort||''}`);
}

function setValueProcOriginal(data) {
  let {
    procedure,
    negotiation,
    isParticular = false,
    isMedical = false,
    fixValueOriginal = true,
    event = {},
  } = data;

  if(!negotiation) {
    console.error('Not found negotiation!');
    return null;
  }

  if (event) {
    const _ctx = createProcedureTeamContext(event, procedure);
    const _accommodation = _ctx?.isTabMode ? (_ctx.accommodation ?? event.accommodation) : event.accommodation;
    const result = checkIfProcIsValuePerHour(procedure, _accommodation, negotiation.billingPerHourGroups);
    if (result.isPerHour && result.billingPerHour) {
      calculateProcValuePerHour(procedure, event, negotiation, result.billingPerHour);
      procedure.type = ProcedureType.KVALUEPERHOUR;
    }
  }

  procedure.value = NumberUtils.currency(procedure.value);
  procedure.valueOriginal = NumberUtils.currency(procedure.valueOriginal);

  if(isParticular) {
    procedure.userCustom ||= status.ProcedureUserCustom.TABLE;
  }
  else {
    // Todos os procedimentos não particulares, tem userCustom === 'TABLE'
    procedure.userCustom = status.ProcedureUserCustom.TABLE;
  }

  // O valor do procedimento já é o valor final, então nada a sser feito
  if(procedure.userCustom === status.ProcedureUserCustom.FINAL) {
    procedure.value = procedure.valueOriginal;
    addRowId(procedure);
    return procedure;
  }

  // Não corrigir valor de base se for do tipo ProcedureUserCustom.BASE ou ProcedureUserCustom.FINAL. Pode ser ignorado nos mobiles
  if(fixValueOriginal && procedure.userCustom === status.ProcedureUserCustom.TABLE) {
    switch (procedure.type) {
      case ProcedureType.KCBHPM:
      case ProcedureType.KOVERRIDEPORTE:
        if (negotiation.isAnesthetisticIndicator) { procedure =  setValurProcByIndicator({procedure, negotiation}); }
        else if(negotiation.hasValues) { procedure.valueOriginal = NumberUtils.currency(procedure.valueTable); }
        else if(!negotiation.hasPortes) { procedure.valueOriginal = 0; }
        else { procedure = setValueProcByPorte({procedure: procedure, negotiation: negotiation, isMedical: isMedical}); }

        if (negotiation.proportion !== 1) { procedure.valueOriginal = procedure.valueOriginal * NumberUtils.parseFloat(negotiation.proportion, 1); }
        break;
      case ProcedureType.KOVERRIDE:
        const overrideOriginal = negotiation.overridesProcedures?.find((a)=> a.idProc === procedure.idProc) || {};
        procedure.valueOriginal = NumberUtils.currency(overrideOriginal.value || 0);
        break;
      case ProcedureType.KCUSTOM:
        const customOriginal = negotiation.customsProcedures?.find((a)=>a.id === procedure.id);
        if(customOriginal) {
          procedure.valueOriginal = NumberUtils.currency(customOriginal.value);
        }
        else { console.warn('procedure KCUSTOM not found on negotiations', procedure); }
        break;
      case ProcedureType.KPACKAGE:
        setOriginalValuePackage(procedure, event, negotiation, isMedical);
        break;
      case ProcedureType.KOVERRIDEINDICATOR:
        procedure =  setValurProcByIndicator({procedure, negotiation});
        break;
    }
  }

  procedure.value = NumberUtils.currency(procedure.value);
  procedure.valueBase = NumberUtils.currency(procedure.valueBase);
  procedure.valueChanged = NumberUtils.currency(procedure.valueChanged);

  addRowId(procedure);

  // console.trace('Super teste', procedure.value, procedure);
  return procedure;
}
exports.setValueProcOriginal = setValueProcOriginal;

function addRowId(procedure) {
  // Retrocompatibilidade, autofix
  if (!procedure.rowId) {
    startFirebase();
    procedure.rowId = firebase.firestore().collection('procedures').doc().id;
  }

  return procedure;
}

function setValurProcByIndicator(data) {
  const {
    procedure,
    negotiation,
  } = data;
  if (procedure.indicadorAnestesico) {
    const indicatorAux = negotiation.anesthetisticIndicators?.[procedure.indicadorAnestesico] || {};
    procedure.valueOriginal = (indicatorAux.amount || 0) * (negotiation.utm || 0);
  } else {
    procedure.valueOriginal = NumberUtils.currency(procedure.valueTable || 0);
  }

  return procedure;
}

/**
 * Calcula valueOriginal do procedimento baseado no porte e negociação.
 * Para empresas MEDICAL usa procedure.porte direto.
 * Para empresas ANESTHETIST mapeia porteAnestesico via PorteAnestesico2Porte.
 * @param {Object} data
 * @param {Object} data.procedure - Procedimento com porte e porteAnestesico
 * @param {Object} data.negotiation - Negociação com portesMap
 * @param {boolean} [data.isMedical=false] - Se empresa é do tipo MEDICAL
 * @returns {Object} procedure com valueOriginal calculado
 */
function setValueProcByPorte(data) {
  const {
    procedure,
    negotiation,
    isMedical = false
  } = data;
  let porte = procedure?.porte;
  const portePercent = NumberUtils.parseFloat(procedure?.portePercent, 1) || 1;
  procedure.valueOriginal = 0;

  if (!isMedical) {
    porte = procedure?.porteAnestesico;
    if(porte === -1) {
      porte = procedure?.porte;
    } else {
      porte = PorteAnestesico2Porte[porte];
    }
  }

  if(negotiation.portesMap?.[porte]?.value) {
    procedure.valueOriginal = NumberUtils.currency(negotiation.portesMap?.[porte]?.value) * portePercent;
  }

  return procedure;
}

/**
 * Define valueOriginal de um item de pacote baseado no seu typeValue.
 * Suporta tipos VALUE, PORTE, HOUR e INDICATOR.
 * @param {Object} packageItem - Item do pacote com typeValue
 * @param {Object} event - Evento médico
 * @param {Object} negotiation - Negociação com packages e portesMap
 * @param {boolean} [isMedical=false] - Se empresa é do tipo MEDICAL
 * @returns {Object} packageItem com valueOriginal definido
 */
function setOriginalValuePackage(packageItem, event, negotiation, isMedical = false) {

  switch (packageItem.typeValue) {
    case PackageType.VALUE:
      const packageOriginal = negotiation.packages.find((a)=>a.id === packageItem.id);
      if(packageOriginal) {
        packageItem.valueOriginal = NumberUtils.currency(packageOriginal.value);
      }
      else {
        console.warn('procedure KPACKAGE not found on negotiations', packageItem);
      }
      break;
    case PackageType.PORTE:
      setValueProcByPorte({procedure: packageItem, negotiation, isMedical});
      break;
    case PackageType.HOUR:
      const billingPerHour = negotiation.packages?.find((a)=> a.id === packageItem.id);
      calculateProcValuePerHour(packageItem, event, negotiation, billingPerHour);
      break;
    case PackageType.INDICATOR:
      setValurProcByIndicator({procedure: packageItem, negotiation});
      break;
    default:
      packageItem.valueOriginal = 0;
      console.warn('Package without value type');
      break;
  }

  return packageItem;
}

/**
 * Papéis que não têm campo próprio no evento e por isso não seriam reconstruídos
 * aqui: fonoaudiólogo, solicitante e "executado em nome de" vivem apenas em
 * `actors`, editados pela tela de evento. Zerar a lista sem preservá-los apaga o
 * que ninguém sabe repor.
 *
 * O cirurgião auxiliar está na mesma situação — foi criado depois dos atores e
 * nunca ganhou campo na raiz do evento, como o próprio
 * `getActorInEventByType` registra. Não aparecia aqui porque a tela de evento
 * só chama `setTeamInEvent` com `actors` vazio; a importação chama sempre, e
 * sem esta linha o auxiliar que a planilha traz é apagado no primeiro recálculo
 * (#1178).
 */
const TEAM_TYPES_WITHOUT_EVENT_FIELD = [
  status.TeamTypes.KPHONOAUDIOLOGIST,
  status.TeamTypes.KREQUESTER,
  status.TeamTypes.KOVERRIDE_EXECUTANT,
  status.TeamTypes.KASSISTANT_SURGEON,
];

function setTeamInEvent(event, revenueConfigs) {
  const TeamTypes = status.TeamTypes;

  event.actors = (event.actors || []).filter(
    (actor) => TEAM_TYPES_WITHOUT_EVENT_FIELD.includes(actor?.type)
  );
  const actors = [];

  if(event.surgeonId && !event.actors.find(a => a.type === TeamTypes.KSURGEON)) {
    insertActor(event, actors, 'surgeonId', getRevenueConfigByType(revenueConfigs, TeamTypes.KSURGEON, 0));
  }

  if(event.anesthetistId && !event.actors.find(a => a.type === TeamTypes.KANESTHETIST)) {
    insertActor(event, actors, 'anesthetistId', getRevenueConfigByType(revenueConfigs, TeamTypes.KANESTHETIST, 0));
  }

  if(event.secondaryAnesthetistId && !event.actors.find(a => a.type === TeamTypes.KASSISTANT_ANESTHETIST)) {
    insertActor(event, actors, 'secondaryAnesthetistId', getRevenueConfigByType(revenueConfigs, TeamTypes.KASSISTANT_ANESTHETIST, 0, TeamTypes.KSECONDARY_ANESTHETIST));
  }

  if(event.thirdAnesthetistId && !event.actors.find(a => a.type === TeamTypes.KASSISTANT_ANESTHETIST)) {
    insertActor(event, actors, 'thirdAnesthetistId', getRevenueConfigByType(revenueConfigs, TeamTypes.KASSISTANT_ANESTHETIST, 1));
  }

  if(event.residentId && !event.actors.find(a => a.type === TeamTypes.KRESIDENT_ANESTHETIST)) {
    insertActor(event, actors, 'residentId', getRevenueConfigByType(revenueConfigs, TeamTypes.KRESIDENT_ANESTHETIST, 0));
  }

  event.actors = event.actors.concat(actors);

  return event;
}
exports.setTeamInEvent = setTeamInEvent;
function getRevenueConfigByType(revenueConfigs, type, order = 0, typeDefault = null) {
  revenueConfigs ||= InsuranceDefault.revenueConfigs;
  let revenueConfig = revenueConfigs.find(a => a.type === type);
  if (!revenueConfig && typeDefault) { revenueConfig = revenueConfigs.find(a => a.type === typeDefault); }
  if (revenueConfig?.team) { revenueConfig = revenueConfig.team.find(a => a.order === order); }

  /**
   * Validação extra para garantir que haja pelo menos uma configuração default
   * */
  if (!revenueConfig) { revenueConfig = InsuranceDefault.revenueConfigs.find(a => a.type === type); }
  return revenueConfig;
}

function insertActor(event, actors, field, revenueConfig) {
  const id = event[field] || null;

  const actor = {
    id: id || null,
    type: revenueConfig.type || null,
    order: revenueConfig.order || 0,
    revenue: revenueConfig.enable || false,
    percentRevenue: revenueConfig.percentRevenue || 0,
    grauPart: revenueConfig.grauPart || '',
  };

  return actors.push(actor);
}

function fixTmpSecondaryAnesthetistInRevenue(revenueConfigs) {
  const secondaryAnesthetist = revenueConfigs.find(a => a.type === status.TeamTypes.KSECONDARY_ANESTHETIST);
  if(!secondaryAnesthetist || !secondaryAnesthetist.enable) { return revenueConfigs; }

  const indexItemAssistant = revenueConfigs.findIndex(a => a.type === status.TeamTypes.KASSISTANT_ANESTHETIST);
  const defaultItemAssistant = {
    type: status.TeamTypes.KASSISTANT_ANESTHETIST,
    enable: false,
    percentRevenue: 0,
    grauPart: '',
    team: [
      {
        type: status.TeamTypes.KASSISTANT_ANESTHETIST,
        enable: true,
        order: 0,
        percentRevenue: 0.3,
        grauPart: '07', // Vem com o default da ANS
      },
      {
        type: status.TeamTypes.KASSISTANT_ANESTHETIST,
        enable: true,
        order: 1,
        percentRevenue: 0,
        grauPart: 'nao_fatura_pela_ans', // Com base nas regras da ANS, isso não é enviado para faturamento dos convênios.
      },
    ]
  };

  if (indexItemAssistant >= 0) {
    revenueConfigs[indexItemAssistant].enable = !!secondaryAnesthetist.enable;

    const indexSecondaryAnesthetist = revenueConfigs[indexItemAssistant]?.team?.findIndex(a => a.order === 0);
    if (indexSecondaryAnesthetist >= 0) {
      revenueConfigs[indexItemAssistant].team = [{
        enable: secondaryAnesthetist.enable,
        grauPart: secondaryAnesthetist.grauPart,
        percentRevenue: secondaryAnesthetist.percentRevenue,
        type: status.TeamTypes.KASSISTANT_ANESTHETIST,
        order: 0,
      }, _.cloneDeep({...defaultItemAssistant.team[1], percentRevenue: 0,})];
    }
  } else {
    defaultItemAssistant.enable = !!secondaryAnesthetist.enable;
    defaultItemAssistant.team[0] = {
      enable: secondaryAnesthetist.enable,
      grauPart: secondaryAnesthetist.grauPart,
      percentRevenue: secondaryAnesthetist.percentRevenue,
      type: status.TeamTypes.KASSISTANT_ANESTHETIST,
      order: 0,
    };
    revenueConfigs.push(defaultItemAssistant);
  }

  revenueConfigs = _.reject(revenueConfigs, (a) => a.type === status.TeamTypes.KSECONDARY_ANESTHETIST);

  return revenueConfigs;
}

/**
 * Applies revenue configuration to a procedure and reconciles its team actors.
 *
 * Reads the revenue configs from the negotiation, decides which actors earn
 * revenue, and writes `procedure.value` / `procedure.revenueTeam`. Actor-level
 * fields (`revenue`, `percentRevenue`, `grauPart`) are computed against a
 * local deep clone of `event.actors`. The clone is written back onto
 * `event.actors` only when the caller is NOT in per-procedure-teams (tab)
 * mode, preserving legacy behavior for all existing flag-OFF callers.
 *
 * When `ctx.isTabMode` is true the original `event.actors` array is left
 * untouched, enabling multi-tab events to price each procedure independently
 * without cross-contamination (see ticket #707 and sub-issue #711).
 *
 * @param {object} procedure - Procedure being priced. Mutated in place.
 * @param {object} negotiation - Negotiation supplying revenueConfigs and rules.
 * @param {object} event - Event owning the actors (read-only under flag-ON).
 * @param {object} [company] - Company context used for billing-type decisions.
 * @param {object} [ctx] - ProcedureTeamContext; defaults to one derived from
 *   `event` + `procedure` for backwards compatibility with direct callers.
 * @returns {object} The mutated procedure.
 */
function setTeamAndValue(procedure, negotiation, event, company, ctx) {
  ctx ||= createProcedureTeamContext(event, procedure);
  negotiation.revenueConfigs ||= [
    {
      type: status.TeamTypes.KANESTHETIST,
      enable: true,
      percentRevenue: 1,
      grauPart: '06',
    }
  ];
  const revenueConfigs = fixTmpSecondaryAnesthetistInRevenue(_.cloneDeep(negotiation.revenueConfigs));

  // Work on a local clone of actors; write back only when NOT in tab mode so
  // flag-OFF callers keep their legacy mutation contract. Under flag-ON,
  // ctx.actors drives actor selection:
  //   - Array (even empty []): authoritative — empty means "no team for this
  //     tab" by user intent; no fallback to event.actors.
  //   - null: tab carries no actor roster (date-only tab) — fall back to
  //     event.actors for pricing without mutating the tab or event.
  const tabActors = ctx?.isTabMode && ctx.actors != null
    ? ctx.actors
    : null;
  const actorsSource = tabActors !== null ? tabActors : (event.actors || []);
  const workingActors = _.cloneDeep(actorsSource);

  // redefinindo o valor de base para aplicar os modificadores
  procedure.valueBase = procedure.valueOriginal || 0;
  if (procedure.userCustom !== status.ProcedureUserCustom.FINAL) {
    procedure.valueBase *= NumberUtils.parseFloat(procedure.proportion, 1);

    // techniquesUsed só não é aplicada no caso de ProcedureUserCustom.FINAL
    procedure.techniqueUsed ||= status.techniquesUsed.KConventional;
    if (negotiation.enableTechniqueUsed && procedure.userCustom) {
      const techniqueUsedValue = negotiation.techniquesUsed?.[procedure.techniqueUsed] || 1;
      procedure.valueBase *= NumberUtils.parseFloat(techniqueUsedValue);
      procedure.techniqueUsedProportion = techniqueUsedValue;
    }

    const ignoreCBHPMIncreases = negotiation.ignoreCBHPMIncreases?.typesEvent?.includes(event.type) || negotiation.ignoreCBHPMIncreases?.techniquesUsed?.includes(procedure.techniqueUsed);

    // Verificar se devem ser aplicadas as regras como na CBHPM
    if ((procedure.useAsCBHPM ||
        ((!event.healthInsurance?.isParticular || (event.healthInsurance?.isParticular && negotiation?.applyCBHPMRules)) &&
          (procedure.type === ProcedureType.KCBHPM || procedure.type === ProcedureType.KOVERRIDE || procedure.type === ProcedureType.KOVERRIDEPORTE || procedure.type === ProcedureType.KOVERRIDEINDICATOR))) &&
      !ignoreCBHPMIncreases
    ) {
      calculateProportions(procedure, event, negotiation, ctx);
    }
  } else {
    let percentTotal = 0;
    for (const actorIndex in workingActors) {
      const actor = workingActors[actorIndex];
      let revenueConfig = revenueConfigs.find(a => a.type === actor.type) || {};
      if (revenueConfig.team?.length && revenueConfig.enable) { revenueConfig = revenueConfig.team.find(a => a.order === actor.order) || {}; }

      const percentRevenue = NumberUtils.parseFloat(revenueConfig.percentRevenue || 0);

      if (!!revenueConfig.enable && percentRevenue > 0) { percentTotal += percentRevenue; }
    }

    procedure.valueBase = NumberUtils.parseFloat(procedure.valueBase / percentTotal);
  }

  if (negotiation.enableAttendanceFeeReducingFromProcedure) {
    procedure.valueBase -= Number(procedure.participative || 0);
    if (procedure.valueBase < 0) procedure.valueBase = 0;
  } else if (!company?.flags?.enableAutomaticAttendanceFee) {
    procedure.participative = 0;
  }


  // Em vez disso, inicializar com zero mas preservar o valor original após o cálculo
  procedure.value = 0;
  procedure.revenueTeam = [];

  // Handle billing type - CRITICAL: Default to BILLABLE if not set
  const billingType = procedure.billingType || status.ProcedureBillingType.BILLABLE;

  // Handle NOT_BILLABLE case
  if (billingType === status.ProcedureBillingType.NOT_BILLABLE) {
    procedure.value = 0;
    procedure.revenueTeam = [];
    // Set all actors as non-revenue
    for (const actorIndex in workingActors) {
      workingActors[actorIndex].revenue = false;
      workingActors[actorIndex].percentRevenue = 0;
    }
    if (!ctx?.isTabMode) { event.actors = workingActors; }
    return procedure;
  }

  // Determine which team type should be the main actor based on company billing type
  let mainActorType = null;
  let mainActorFound = false;
  if (billingType === status.ProcedureBillingType.ONLY_MAIN_ACTOR) {
    if (company?.billingType === status.CompanyBillingType.ANESTHETIST) {
      mainActorType = status.TeamTypes.KANESTHETIST;
    } else if (company?.billingType === status.CompanyBillingType.MEDICAL) {
      mainActorType = status.TeamTypes.KSURGEON;
    }
  }

  for (const actorIndex in workingActors) {
    const actor = workingActors[actorIndex];

    // For ONLY_MAIN_ACTOR, check if we should process this actor
    if (billingType === status.ProcedureBillingType.ONLY_MAIN_ACTOR && mainActorType) {
      const isMainActorType = actor.type === mainActorType;

      // Only process the first occurrence of the main actor type with revenue enabled
      if (!isMainActorType) {
        // Not the main actor type - skip billing for this actor
        workingActors[actorIndex].revenue = false;
        workingActors[actorIndex].percentRevenue = 0;
        continue;
      } else if (mainActorFound) {
        // Already found the main actor - skip additional actors of same type
        workingActors[actorIndex].revenue = false;
        workingActors[actorIndex].percentRevenue = 0;
        continue;
      }
    }

    const revenueConfig = revenueConfigs.find(a => a.type === actor.type) || {};
    let rcTeamElement = null;
    if (revenueConfig.team?.length && revenueConfig.enable) { rcTeamElement = revenueConfig.team.find(a => a.order === actor.order) || {}; }

    workingActors[actorIndex].revenue = !!revenueConfig.enable;
    workingActors[actorIndex].percentRevenue = NumberUtils.parseFloat(rcTeamElement?.percentRevenue || revenueConfig?.percentRevenue || 0);
    workingActors[actorIndex].grauPart = rcTeamElement?.grauPart || revenueConfig.grauPart || '';

    // Mark that we found the main actor if applicable
    if (billingType === status.ProcedureBillingType.ONLY_MAIN_ACTOR &&
        mainActorType &&
        actor.type === mainActorType &&
        workingActors[actorIndex].revenue) {
      mainActorFound = true;
    }

    if (workingActors[actorIndex].revenue) { setPersonTeamInProc(procedure, workingActors[actorIndex]); }
  }

  if (procedure.userCustom !== status.ProcedureUserCustom.FINAL) {
    const uco = negotiation.uco?.[event.type] || {};
    if (uco.enableUCO && uco.valueUCO > 0 && procedure.uco > 0) {
      const finalValueUCO = uco.valueUCO * procedure.uco;
      procedure.value += finalValueUCO;
    }
  }

  if (!ctx?.isTabMode) {
    event.actors = workingActors;
  } else if (
    ctx
    && ctx.tabRowId
    && Array.isArray(event.procedureTeamTabs)
    && event.procedureTeamTabs.length > 0
  ) {
    // Reason: per-tab writeback. setTeamAndValue computes negotiation-derived
    // revenue/percentRevenue/grauPart into workingActors, but in tab mode the
    // legacy writeback at the line above is intentionally skipped to keep
    // event.actors pristine. Without ANY writeback, tab.actors retains the
    // stale defaults the user typed at pick time (revenue=false,
    // percentRevenue=0, grauPart='') while procedure.revenueTeam reflects the
    // correct computed values — the two drift apart on save. Persist the
    // computed values onto the resolved tab in place so tab.actors stays in
    // lockstep with procedure.revenueTeam.
    const tab = event.procedureTeamTabs.find((t) => t && t.rowId === ctx.tabRowId);
    if (tab) {
      tab.actors = workingActors;
    }
  }
  return procedure;
}
exports.setTeamAndValue = setTeamAndValue;

function setPersonTeamInProc(procedure, actor) {
  if (!actor) {
    return procedure;
  }

  const value = procedure.valueBase * actor.percentRevenue;
  procedure.value += value;
  procedure.revenueTeam.push(
    {
      type: actor.type,
      order: actor.order,
      grauPart: actor.grauPart,
      id: actor.id,
      value: NumberUtils.currency(value),
    }
  );
  return procedure;
}

function calculateProportions(proc, event, negotiation, ctx) {
  const resolvedAccommodation = ctx?.isTabMode ? (ctx.accommodation ?? event.accommodation) : event.accommodation;
  if (negotiation.enableCustomProportions) {

    if(negotiation?.enableCustomProportionsByEventType?.[event.type]) {
      if(negotiation.customProportionTypeByEventType?.[event.type] === CustomProportionType.VALUE) {
        proc.valueBase += negotiation.accommodationValuesByEventType?.[event.type]?.[resolvedAccommodation] || 0;

        if (event.isEmergency) {proc.valueBase += negotiation.emergencyValueByEventType?.[event.type] || 0; }
      } else {
        proc.valueBase *= negotiation.accommodationFactorsByEventType?.[event.type]?.[resolvedAccommodation] || InsuranceDefault.accommodationFactors[resolvedAccommodation];

        if (event.isEmergency) { proc.valueBase *= (negotiation.emergencyFactorByEventType?.[event.type] || InsuranceDefault.emergencyFactor); }
      }
      return proc;

    } else {
      if (negotiation.customProportionType === CustomProportionType.VALUE) {
        proc.valueBase += negotiation.accommodationValues?.[resolvedAccommodation] || 0;

        if (event.isEmergency) {proc.valueBase += negotiation.emergencyValue || 0; }
      } else {
        proc.valueBase *= negotiation.accommodationFactors?.[resolvedAccommodation] || InsuranceDefault.accommodationFactors[resolvedAccommodation];
        if (event.isEmergency) { proc.valueBase *= (negotiation.emergencyFactor || InsuranceDefault.emergencyFactor); }
      }
      return proc;
    }
  }

  proc.valueBase *= InsuranceDefault.accommodationFactors[resolvedAccommodation] || 1;
  if (event.isEmergency) { proc.valueBase *= InsuranceDefault.emergencyFactor; }

  return proc;
}

exports.calculateProportions = calculateProportions;

function checkIfProcIsValuePerHour(proc, accommodation, billingPerHourGroups = []) {
  let billingPerHour = null;
  for (const billingPerHourGroup of billingPerHourGroups) {
    if(billingPerHour) { break; }
    const index = billingPerHourGroup.procedures.findIndex(procedure => procedure.id === proc.id);
    if (index !== -1) { billingPerHour = billingPerHourGroup; }
  }

  return {isPerHour: !!billingPerHour, billingPerHour: billingPerHour};
}
exports.checkIfProcIsValuePerHour = checkIfProcIsValuePerHour;

// Test seam (issue #718): expose calculateProcValuePerHour so the per-tab
// refactor can be covered directly without going through setValueProc's
// broader surface. No behavior change — exposure only.
exports.calculateProcValuePerHour = calculateProcValuePerHour;

function calculateProcValuePerHour(proc, event, negotiation, billingPerHour) {
  proc.proportion = 1;

  // Issue #718 / M2-I03: source the interval from the ProcedureTeamContext so
  // that matched tabs can override event-level times. Flag-OFF paths continue
  // to resolve from event-level fields (ctx.isTabMode === false) keeping
  // byte-parity with the legacy behaviour.
  const ctx = createProcedureTeamContext(event, proc);

  const eventHasProcedureInterval = (event.procedureStart && event.procedureEnd) || (event._procedureStart && event._procedureEnd);
  const eventHasAnesthesiaInterval = (event.anesthesiaStart && event.anesthesiaEnd) || (event._anesthesiaStart && event._anesthesiaEnd);

  let hasProcedureInterval = eventHasProcedureInterval;
  let hasAnesthesiaInterval = eventHasAnesthesiaInterval;
  let useCtxInterval = false;

  if (ctx.isTabMode) {
    const ctxHasProcedureInterval = Boolean(ctx.procedureStart && ctx.procedureEnd);
    const ctxHasAnesthesiaInterval = Boolean(ctx.anesthesiaStart && ctx.anesthesiaEnd);

    // Null -> fallback rule: a tab with all time fields null yields to the
    // event-level defaults already assigned above.
    if (ctxHasProcedureInterval || ctxHasAnesthesiaInterval) {
      hasProcedureInterval = ctxHasProcedureInterval;
      hasAnesthesiaInterval = ctxHasAnesthesiaInterval;
      useCtxInterval = true;
    }
  }

  let intervalToUse;

  if (hasProcedureInterval) {
    intervalToUse = 'procedureInterval';
  } else if (hasAnesthesiaInterval) {
    intervalToUse = 'anesthesiaInterval';
  } else {
    // Se não tem nenhum dos dois, retorna valor zerado
    proc.value = 0;
    proc.valueOriginal = 0;
    return proc;
  }

  const diffHour = getDiffHourBetweenStartAndEndIntervalType(event, intervalToUse, useCtxInterval ? ctx : null);

  const resolvedAccommodation = ctx?.isTabMode ? (ctx.accommodation ?? event.accommodation) : event.accommodation;
  const defaultHourByAccommodation = billingPerHour.config.defaultHour.hourByAccommodation[resolvedAccommodation];
  let value = 0;
  for (let i = 1; i <= diffHour; i++) {
    const hour = billingPerHour.config.hours.find(a => a.order === i);
    if (hour) {
      const hourByAccommodation = hour.hourByAccommodation[resolvedAccommodation];
      if (hourByAccommodation) {
        value += getValuePerHourByValueOrPorte(hourByAccommodation, negotiation);
      }
    } else {
      value += getValuePerHourByValueOrPorte(defaultHourByAccommodation, negotiation);
    }
  }
  proc.value = value;
  proc.valueOriginal = value;

  return proc;
}

function getValuePerHourByValueOrPorte(hourByAccommodation, negotiation) {
  switch (hourByAccommodation.type) {
    case GroupPerHourType.VALUE:
      return hourByAccommodation.value * hourByAccommodation.proportion;
    case GroupPerHourType.PORTE:
      const porte = hourByAccommodation.isAnesthetic ? PorteAnestesico2Porte[hourByAccommodation.porteAnestesico] : hourByAccommodation.porte;
      const proportion = NumberUtils.parseFloat(hourByAccommodation.proportion, 1);

      let value = 0;
      if(negotiation.portesMap?.[porte]?.value) {
        value = NumberUtils.currency(negotiation.portesMap?.[porte]?.value) * proportion;
      }
      return value;
    case GroupPerHourType.INDICATOR:
      return setValurProcByIndicator({procedure: hourByAccommodation, negotiation}).valueOriginal * hourByAccommodation.proportion;
  }
}

function getDiffHourBetweenStartAndEndIntervalType(event, baseValueHour, ctx) {
  const intervalType = baseValueHour === 'procedureInterval' ? 'procedure' : 'anesthesia';

  const baseValueHourStart = `${intervalType}Start`;
  const baseValueHourEnd = `${intervalType}End`;

  let startTime = null;
  let endTime = null;

  // Invariant: flag-OFF byte-parity. The caller only passes a non-null ctx
  // when tab-mode carries the relevant HH:MM strings; any other code path
  // (flag OFF, tab without times) falls through to the legacy branches.
  if (ctx?.isTabMode && ctx[baseValueHourStart] && ctx[baseValueHourEnd] && ctx.dtProcedure) {
    const dtProcedureMoment = getDtAsMoment(ctx.dtProcedure);

    const findStart = ctx[baseValueHourStart].match(/(.*):(.*)/);
    const findEnd = ctx[baseValueHourEnd].match(/(.*):(.*)/);

    if (!findStart?.[1] || !findStart?.[2] || !findEnd?.[1] || !findEnd?.[2]) {
      return 0;
    }

    startTime = moment(dtProcedureMoment);
    startTime.set('hour', parseInt(findStart[1]));
    startTime.set('minute', parseInt(findStart[2]));

    endTime = moment(dtProcedureMoment);
    endTime.set('hour', parseInt(findEnd[1]));
    endTime.set('minute', parseInt(findEnd[2]));
  }
  else if (event.dtProcedure && event[`_${baseValueHourStart}`] && event[`_${baseValueHourEnd}`]) {
    const dtProcedureMoment = getDtAsMoment(event.dtProcedure);

    const findStart = event[`_${baseValueHourStart}`].match(/(.*):(.*)/);
    const findEnd = event[`_${baseValueHourEnd}`].match(/(.*):(.*)/);

    if (!findStart?.[1] || !findStart?.[2] || !findEnd?.[1] || !findEnd?.[2]) {
      return 0;
    }

    startTime = moment(dtProcedureMoment);
    startTime.set('hour', parseInt(findStart[1]));
    startTime.set('minute', parseInt(findStart[2]));

    endTime = moment(dtProcedureMoment);
    endTime.set('hour', parseInt(findEnd[1]));
    endTime.set('minute', parseInt(findEnd[2]));
  }
  else if (event[baseValueHourStart] && event[baseValueHourEnd]) {
    startTime = getDtAsMoment(event[baseValueHourStart]);
    endTime = getDtAsMoment(event[baseValueHourEnd]);
  }
  else {
    return 0;
  }


  return DateUtils.customBetterCalculateTimeDifference(startTime, endTime, {
    format: 'hours',
    roundUp: true
  });
}

function getDtAsMoment(dt) {
  let dtAux;
  if (dt?.seconds > 0 || dt?.nanoseconds > 0) {
    dtAux = moment((dt.seconds * 1000) + (dt.nanoseconds / 10e6));
  } else if (dt && !dt?.isValid?.()) {
    dtAux = moment(dt);
  } else {
    dtAux = moment(dt.toDate());
  }
  return dtAux;
}

/**
 * O detailedDiff não registrou nenhuma diferença?
 *
 * `detailedDiff` devolve sempre `{added, deleted, updated}`, e só inclui um caminho
 * quando há de fato o que reportar — mas o valor de uma deleção é `undefined`, que o
 * `transverseUndefinedToNull` converte em `null` antes de isto rodar. Checar por
 * valor, portanto, não serve: o que conta é existir alguma folha. A varredura é
 * profunda porque a diferença pode estar em `procedures.3.value`, e um teste apenas
 * no primeiro nível veria só a chave `procedures`.
 *
 * @param {Object} diff retorno de DeepObjectDiff.detailedDiff
 * @return {boolean} true quando não há nenhuma folha em added/deleted/updated
 */
function isEmptyDetailedDiff(diff) {
  // `isRoot` separa dois `{}` de significado oposto. Na RAIZ (`added`, `deleted`, `updated`),
  // objeto sem chaves quer dizer "nada a reportar nesta categoria" — é o caso normal do evento
  // intacto. ANINHADO, quer dizer que um campo novo entrou no evento e o valor dele é um objeto
  // vazio: `{added: {procedureTeamTab: {}}}` é um map recém-criado, diferença real. Sem a
  // distinção, esse diff virava `unchanged`, o autoFix não gravava, e o mesmo evento voltava em
  // toda rodada do VerifyEvents sem nunca ser corrigido.
  const isEmptyDeep = (value, isRoot) => {
    if(value === null || typeof value !== 'object') {
      return false;
    }
    const keys = Object.keys(value);
    if(!keys.length) {
      return isRoot;
    }
    return keys.every((key) => isEmptyDeep(value[key], false));
  };
  return isEmptyDeep(diff?.added, true) && isEmptyDeep(diff?.deleted, true) &&
    isEmptyDeep(diff?.updated, true);
}
exports.isEmptyDetailedDiff = isEmptyDetailedDiff;

exports.autoFix = async function({event, before, company = {}, logInfo = {}, persist=false}) {
  startFirebase();
  if(!event) {
    return {status: 'error', msg: 'Not found event'};
  }
  if(!event || !event.healthInsuranceId) {
    return {status: 'error', msg: 'Not found event or event.healthInsuranceId', before};
  }

  const negotiation = exports.getNegotiation(event.dtProcedure, event.healthInsurance);
  if(!negotiation) {
    return {status: 'error', msg: 'Not found negotiation', before};
  }
  event.negotiationId = negotiation.id || null;
  const orphanProcedures = exports.reloadProceduresValuesAndFilter({event: event, allProcedures: null, hardFix: true, company: company});
  if(orphanProcedures.lstRemoved?.length) {
    return {status: 'error', msg: 'Have Orphans, Auto fix can`t fix that', before, orphanProcedures};
  }
  calculateEventValues(event);

  event.healthInsurance = {
    name: event.healthInsurance?.name || '',
    hasSendGuia: event.healthInsurance?.hasSendGuia || false,
  };
  delete event.healthInsurance;
  delete before.healthInsurance;
  const diff = ObjectUtils.transverseUndefinedToNull(DeepObjectDiff.detailedDiff(before, event));

  // Evento intacto não é correção, e gravá-lo custa caro em três frentes: uma escrita
  // por evento sem conteúdo, um registro em eventsAutoFixLog para cada uma, e o
  // carimbo de meta.updatedAt/updatedEnv='AutoFix' num evento que ninguém mudou —
  // este último envenena o próprio filtro por período de atualização que a
  // verificação usa para se orientar na rodada seguinte. Numa varredura de milhares
  // de eventos, os poucos realmente corrigidos ficariam enterrados entre eles.
  if(isEmptyDetailedDiff(diff)) {
    return {status: 'unchanged', before, after: event, diff};
  }

  if(persist) {
    await firebase.firestore().collection('eventsAutoFixLog').add({
      meta: {
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        createdBy: logInfo?.userId || '',
        createdByName: logInfo?.userName || '',
      },
      before,
      after: event,
      diff,
      logInfo
    });
    await firebase.firestore().collection('events').doc(event.id).set({
      ...event,
      meta: {
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        updatedEnv: 'AutoFix',
        updatedBy: logInfo?.userId || '',
        updatedByName: logInfo?.userName || '',
      }
    });
  }

  return {
    status: 'ok',
    before,
    after: event,
    diff
  };
};

/**
 *
 * @param procedure
 * @param {boolean} isParticular
 * @param {''|'RECEIVE'|'LOSS'|'GLOSA'} doActionOnFinalize Precisa, necessariamente, passar a ação correta caso a flag 'finish' esteja como true.
 * @return {any}
 */
function calculateProcedureFinish(procedure, isParticular= false, doActionOnFinalize = '') {
  let result = NumberUtils.currency(
    (procedure.totalReceived + procedure.totalLoss + procedure.totalGlosado + procedure.totalDiscount) - procedure.value);
  if(result < 0) {
    result = NumberUtils.currency(Math.abs(result));

    switch (doActionOnFinalize) {
      case ActionsOnFinishEvent.RECEIVE:
        procedure.totalReceived += result;
        break;
      case ActionsOnFinishEvent.GLOSA:
      case ActionsOnFinishEvent.LOSS:
        if (!isParticular) {
          procedure.totalGlosado += result;
        } else {
          procedure.totalLoss += result;
        }
        break;
      default:
        throw new Error('Ação desconhecida/não permitida no procedimento: ' + doActionOnFinalize);
    }
  } else {
    procedure.totalOver += NumberUtils.currency(result);
  }
  return procedure;
}
exports.calculateProcedureFinish = calculateProcedureFinish;

/**
 *
 * @param expense
 * @param {boolean} isParticular
 * @param {''|'RECEIVE'|'LOSS'|'GLOSA'} doActionOnFinalize Precisa, necessariamente, passar a ação correta caso a flag 'finish' esteja como true.
 * @return {any}
 */
function calculateExpenseFinish(expense, isParticular= false, doActionOnFinalize = '') {
  let result = NumberUtils.currency(
    (expense.totalReceived + expense.totalLoss + expense.totalGlosado + expense.totalDiscount) - expense.totalValue);

  if(result < 0) {
    result = NumberUtils.currency(Math.abs(result));

    switch (doActionOnFinalize) {
      case ActionsOnFinishEvent.RECEIVE:
        expense.totalReceived += result;
        break;
      case ActionsOnFinishEvent.GLOSA:
      case ActionsOnFinishEvent.LOSS:
        if (!isParticular) {
          expense.totalGlosado += result;
        } else {
          expense.totalLoss += result;
        }
        break;
      default:
        throw new Error('Ação desconhecida/não permitida na taxa/despesa: ' + doActionOnFinalize);
    }
  } else {
    expense.totalOver += NumberUtils.currency(result);
  }
  return expense;
}
exports.calculateExpenseFinish = calculateExpenseFinish;

/**
 * Calcula os valores consolidados do evento (taxas, complementações, despesas e procedimentos).
 *
 * Quando o modo per-tab está ativo (flag `isPerProcedureTeamEnabled(event)` ON e
 * `event.procedureTeamTabs` é um array não vazio), a chamada a `setTeamInEvent` é
 * ignorada para não sobrescrever a união de actors construída por `calcTotalProcedures`
 * a partir das abas (ver M2-I04-a, issue #723).
 *
 * @param {any} event
 * @param {boolean} finish
 * @param {''|'RECEIVE'|'LOSS'|'GLOSA'} doActionOnFinalize Precisa, necessariamente, passar a ação caso a flag 'finish' esteja como true.
 * @return {any}
 */
function calculateEventValues(event, finish= false, doActionOnFinalize = '') {
  if (finish && !doActionOnFinalize) {
    throw new Error('Cálculo para finalizar o evento não pode ser executado sem uma ação especificada');
  }

  // Reason (M2-I04-a): no modo per-procedure-team, event.actors é reconstruído
  // pela união das abas dentro de calcTotalProcedures. Pular setTeamInEvent
  // aqui evita clobberar a união com o time event-level derivado dos ids.
  const perProcedureTeamActive = isPerProcedureTeamEnabled(event)
    && Array.isArray(event.procedureTeamTabs)
    && event.procedureTeamTabs.length > 0;

  if (!perProcedureTeamActive && !event.actors?.length) { setTeamInEvent(event); }
  calcTotalAttendanceFee(event, finish, doActionOnFinalize);
  calcTotalComplementation(event, finish, doActionOnFinalize);
  const expensesResult
    = calcTotalExpenses(event, finish, doActionOnFinalize);

  const expenses
    = expensesResult.totals;

  event.multAdditionalData = expensesResult.multAdditionalData || [event.additionalData || {}];

  event.revenueTypes = [];
  event.revenueIds = [];

  const procedures = calcTotalProcedures(event, finish, doActionOnFinalize);

  event.values = {
    ...event.values,
    ...procedures,
    ...expenses,
  };

  calcTotalEvent(event, procedures);
  if(finish && checkIfCanFinalize(event)) {
    finalizeEventStatus(event);
  }
  return event;
}
exports.calculateEventValues = calculateEventValues;

function checkIfCanFinalize(event) {
  const values = event.values;
  const resultAttendanceFee = values.attendanceFee - values.attendanceFeeReceived;

  const resultComplementation =  (values.complementation + values.complementationOver) - (values.complementationReceived + values.complementationLoss);

  const resultExpenses = (values.expenses + values.expensesOver) - (values.expensesReceived + values.expensesLoss + values.expensesDiscount + values.expensesGlosado);

  const resultProcedures = (values.totalProcedures + values.totalProceduresOver) - (values.totalProceduresReceived + values.totalProceduresLoss + values.totalProceduresGlosado + values.totalDiscount);

  return checkDiff(resultAttendanceFee) && checkDiff(resultComplementation) && checkDiff(resultExpenses) && checkDiff(resultProcedures);
}

function checkDiff(value) {
  return Math.abs(value) < 0.05;
}

/**
 *
 * @param {any} event
 * @param {boolean} finish
 * @param {''|'RECEIVE'|'LOSS'|'GLOSA'} doActionOnFinalize Precisa, necessariamente, passar a ação caso a flag 'finish' esteja como true.
 * * E só pode ser recebido, não pode ser executada nenhuma outra para o co-participativo
 * @return {any}
 */
function calcTotalAttendanceFee(event, finish, doActionOnFinalize = '') {
  if (finish && !doActionOnFinalize) {
    throw new Error('Cálculo para finalizar não pode ser executado sem uma ação especificada');
  }

  const values = event.values;
  values.attendanceFee = NumberUtils.currency(values.attendanceFee);
  values.attendanceFeeReceived = NumberUtils.currency(values.attendanceFeeReceived);
  // values.attendanceFeeLoss = NumberUtils.currency(values.attendanceFeeLoss);
  // values.attendanceFeeDiscount = NumberUtils.currency(values.attendanceFeeDiscount);
  // values.attendanceFeeGlosado = NumberUtils.currency(values.attendanceFeeGlosado);

  if(finish && doActionOnFinalize === ActionsOnFinishEvent.RECEIVE && values.attendanceFeeReceived === 0) {
    values.attendanceFeeReceived = NumberUtils.currency(values.attendanceFee);
  }

  event.values = values;
  return event;
}
exports.calcTotalAttendanceFee = calcTotalAttendanceFee;

/**
 *
 * @param {any} event
 * @param {boolean} finish
 * @param {''|'RECEIVE'|'LOSS'|'GLOSA'} doActionOnFinalize Precisa, necessariamente, passar a ação caso a flag 'finish' esteja como true.
 * E só pode ser recebido ou perdido. Não pode ser glosado ('GLOSA').
 * @return {any}
 */
function calcTotalComplementation(event, finish = false, doActionOnFinalize = '') {
  if (finish && !doActionOnFinalize) {
    throw new Error('Cálculo para finalizar não pode ser executado sem uma ação especificada');
  }

  const values = event.values;
  values.complementation = NumberUtils.currency(values.complementation);
  values.complementationReceived = NumberUtils.currency(values.complementationReceived);
  values.complementationLoss = NumberUtils.currency(values.complementationLoss);
  values.complementationOver = NumberUtils.currency(values.complementationOver);
  // values.complementationDiscount = NumberUtils.currency(values.complementationDiscount);
  // values.complementationGlosado = NumberUtils.currency(values.complementationGlosado);

  if (finish && doActionOnFinalize && (doActionOnFinalize === ActionsOnFinishEvent.RECEIVE || doActionOnFinalize === ActionsOnFinishEvent.LOSS)) {
    const resultComplementation = NumberUtils.currency(
      values.complementation - (values.complementationReceived + values.complementationLoss/* + values.complementationGlosado + values.complementationDiscount*/));
    if(resultComplementation > 0) {
      if(doActionOnFinalize === ActionsOnFinishEvent.RECEIVE) {
        values.complementationReceived = NumberUtils.currency(values.complementationReceived + resultComplementation);
      } else if (doActionOnFinalize === ActionsOnFinishEvent.LOSS) {
        values.complementationLoss = NumberUtils.currency(values.complementationLoss + resultComplementation);
      }
    } else {
      values.complementationOver = NumberUtils.currency(Math.abs(resultComplementation));
    }
  }

  event.values = values;
  return event;
}
exports.calcTotalComplementation = calcTotalComplementation;

/**
 * Calcula os totais de procedimentos do evento e os valores derivados associados.
 *
 * Quando `isPerProcedureTeamEnabled(event)` é verdadeiro e `event.procedureTeamTabs`
 * é um array não vazio, `event.actors` (e os derivados `actorsIds`, `actorsTypes`,
 * `actorsTypesIds`) são substituídos pela união deduplicada dos actors de todas as
 * abas, usando `${type}_${id}_${order}` como chave e preservando a primeira ocorrência;
 * quando as abas estão ausentes ou vazias, o caminho legado é preservado intacto
 * (ver M2-I04-b, issue #724).
 *
 * @param {any} event
 * @param {boolean} finish
 * @param {''|'RECEIVE'|'LOSS'|'GLOSA'} doActionOnFinalize Precisa, necessariamente, passar a ação caso a flag 'finish' esteja como true.
 * @return {any}
 */
function calcTotalProcedures(event, finish = false, doActionOnFinalize) {
  const t = {
    totalProcedures: 0,
    totalReceivedFromOver: 0,
    totalProceduresReceived: 0,
    totalProceduresGlosado: 0,
    totalProceduresLoss: 0,
    totalProceduresOver: 0,

    totalDiscount: 0,
    totalInProcessing: 0,
    totalChangedPlus: 0,
    totalChangedLess: 0,
    totalChanged: 0,
  };

  // Reason (M2-I04-b): quando o modo per-procedure-team está ativo e há pelo
  // menos uma aba, event.actors é substituído pela união dos actors de todas
  // as abas. A chave de dedup é `${type}_${id}_${order}` e a ordem preserva
  // primeira ocorrência (caminhando abas em ordem, depois actors em ordem).
  // Arrays vazios ou ausentes caem na lógica legada (sem sobrescrever actors).
  const perProcedureTeam = isPerProcedureTeamEnabled(event);
  const tabs = perProcedureTeam && Array.isArray(event.procedureTeamTabs)
    ? event.procedureTeamTabs
    : null;

  if (tabs && tabs.length > 0) {
    const seen = new Set();
    const union = [];
    for (const tab of tabs) {
      if (!tab || !Array.isArray(tab.actors)) { continue; }
      for (const actor of tab.actors) {
        if (!actor) { continue; }
        const key = `${actor.type}_${actor.id}_${actor.order}`;
        if (seen.has(key)) { continue; }
        seen.add(key);
        union.push(actor);
      }
    }
    if (union.length > 0) {
      event.actors = union;
    }
    // Reason (defesa): se todas as abas existirem mas estiverem vazias de
    // actors, preservamos event.actors para não quebrar calculadores
    // downstream que ainda dependem do roster event-level como fallback.
  }

  for(const pr of event.procedures ||[]) {
    if(pr.rowId==='additional') {
      console.error('Tem coisa errada aqui, não deveria acontecer');
      continue;
    }

    let proc = pr;
    proc.totalReceivedFromOver = NumberUtils.currency(proc.totalReceivedFromOver);
    proc.totalReceived = NumberUtils.currency(proc.totalReceived);
    proc.totalLoss = NumberUtils.currency(proc.totalLoss);
    proc.totalGlosado = NumberUtils.currency(proc.totalGlosado);
    proc.totalDiscount = NumberUtils.currency(proc.totalDiscount || 0);
    proc.value = NumberUtils.currency(proc.value);
    proc.valueOriginal = NumberUtils.currency(proc.valueOriginal);

    proc.totalOver = 0;
    if (finish) { proc = calculateProcedureFinish(proc, event.healthInsurance.isParticular, doActionOnFinalize); }

    const over = NumberUtils.currency((proc.totalReceived + proc.totalLoss + proc.totalGlosado + proc.totalDiscount) - proc.value);
    if(over>0) { proc.totalOver = over; }
    if(over<0) { t.totalInProcessing += Math.abs(over); }
    t.totalProcedures += proc.value;
    t.totalReceivedFromOver += proc.totalReceivedFromOver;
    t.totalProceduresReceived += proc.totalReceived;
    t.totalProceduresGlosado += proc.totalGlosado;
    t.totalProceduresLoss += proc.totalLoss;
    t.totalProceduresOver += proc.totalOver;
    t.totalDiscount += proc.totalDiscount;

    const valueChanged = NumberUtils.currency(proc.valueChanged);
    if (valueChanged > 0) { t.totalChangedPlus += valueChanged; }
    else { t.totalChangedLess += valueChanged; }

    t.totalChanged += Math.abs(valueChanged);

    const defaultTeam =  [
      {
        type: status.TeamTypes.KANESTHETIST,
        grauPart: '06',
        id: event.anesthetistId || null,
        value: proc.value,
      }
    ];

    // Nubca deveria precisar adicionar o default.
    proc.revenueTeam ||= defaultTeam;
    for (const person of proc.revenueTeam) {
      if (person.id && !event.revenueIds.includes(person.id)) {
        event.revenueIds.push(person.id);
      }
      if (person.type && !event.revenueTypes.includes(person.type)) {
        event.revenueTypes.push(person.type);
      }
    }
  }
  event.actorsIds = event.actors.map(a => a.id);
  event.actorsTypes = event.actors.map(a => a.type);
  event.actorsTypesIds = event.actors.map(a => `${a.type}_${a.id}`);
  addOldIdsInEvent(event);

  return {
    totalProcedures: NumberUtils.currency(t.totalProcedures),
    totalReceivedFromOver: NumberUtils.currency(t.totalReceivedFromOver),
    totalProceduresReceived: NumberUtils.currency(t.totalProceduresReceived),
    totalProceduresGlosado: NumberUtils.currency(t.totalProceduresGlosado),
    totalProceduresLoss: NumberUtils.currency(t.totalProceduresLoss),
    totalProceduresOver: NumberUtils.currency(t.totalProceduresOver),

    totalDiscount: NumberUtils.currency(t.totalDiscount),
    totalInProcessing: NumberUtils.currency(t.totalInProcessing),
    totalChangedPlus: NumberUtils.currency(t.totalChangedPlus),
    totalChangedLess: NumberUtils.currency(t.totalChangedLess),
    totalChanged: NumberUtils.currency(t.totalChanged),
  };
}
exports.calcTotalProcedures = calcTotalProcedures;

/**
 * Essa função foi criada para ser utilizada temporariamente como gambiarra porque
 * não temos os atores em todos os ambientes e nem em todos os eventos do sistema, em especial os eventos mais antigos.
 * @param event
 * @return {*}
 */
function addOldIdsInEvent(event) {

  event.anesthetistId          = event.actors?.find(a => a.type === status.TeamTypes.KANESTHETIST)?.id || event.anesthetistId || null;
  event.secondaryAnesthetistId = event.actors?.find(a => a.type === status.TeamTypes.KASSISTANT_ANESTHETIST && a.order === 0)?.id || event.secondaryAnesthetistId || null;
  event.thirdAnesthetistId     = event.actors?.find(a => a.type === status.TeamTypes.KASSISTANT_ANESTHETIST && a.order === 1)?.id || event.thirdAnesthetistId || null;
  event.surgeonId              = event.actors?.find(a => a.type === status.TeamTypes.KSURGEON)?.id || event.surgeonId || null;
  event.residentId             = event.actors?.find(a => a.type === status.TeamTypes.KRESIDENT_ANESTHETIST)?.id || event.residentId || null;

  return event;
}
exports.addOldIdsInEvent = addOldIdsInEvent;

/**
 *
 * @param {any} event
 * @param {boolean} finish
 * @param {''|'RECEIVE'|'LOSS'|'GLOSA'} doActionOnFinalize Precisa, necessariamente, passar a ação caso a flag 'finish' esteja como true.
 * @return {any}
 */
function calcTotalExpenses(event, finish = false, doActionOnFinalize) {
  const t = {
    expenses: 0,
    expensesReceived: 0,
    expensesGlosado: 0,
    expensesLoss: 0,
    expensesOver: 0,
    expensesDiscount: 0,
  };

  for(const additionalData of event.multAdditionalData || []) {
    for (const ex of additionalData.otherExpenses || []) {

      let expense = ex;
      expense.totalValue = NumberUtils.currency(expense.totalValue);
      expense.totalReceived = NumberUtils.currency(expense.totalReceived);
      expense.totalGlosado = NumberUtils.currency(expense.totalGlosado);
      expense.totalLoss = NumberUtils.currency(expense.totalLoss);
      expense.totalDiscount = NumberUtils.currency(expense.totalDiscount);

      expense.totalOver = 0;
      if (finish) { expense = calculateExpenseFinish(expense, event.healthInsurance.isParticular, doActionOnFinalize); }

      t.expenses += NumberUtils.currency(expense.totalValue);
      t.expensesReceived += NumberUtils.currency(expense.totalReceived);
      t.expensesGlosado += NumberUtils.currency(expense.totalGlosado);
      t.expensesLoss += NumberUtils.currency(expense.totalLoss);
      t.expensesOver += NumberUtils.currency(expense.totalOver);
      t.expensesDiscount += NumberUtils.currency(expense.totalDiscount);
    }

    if (event.type === status.EventType.SPSADT) { calcTotalExpensesByType(event, additionalData); }
  }

  return {
    totals: {
      expenses: NumberUtils.currency(t.expenses),
      expensesReceived: NumberUtils.currency(t.expensesReceived),
      expensesGlosado: NumberUtils.currency(t.expensesGlosado),
      expensesLoss: NumberUtils.currency(t.expensesLoss),
      expensesOver: NumberUtils.currency(t.expensesOver),
      expensesDiscount: NumberUtils.currency(t.expensesDiscount),
    },
    multAdditionalData: event.multAdditionalData,
  };
}
exports.calcTotalExpenses = calcTotalExpenses;

function calcTotalExpensesByType(event, additionalData) {
  const totals = {
    totalGasesMedicinals: 0,
    totalDrugs: 0,
    totalOPME: 0,
    totalMaterials: 0,
    totalTaxes: 0,
    totalDayly: 0,
    totalFees: 0,
  };

  const totalValuesToFrom = {
    '01': 'totalGasesMedicinals',
    '02': 'totalDrugs',
    '03': 'totalMaterials',
    '04': 'totalTaxes',
    '05': 'totalDayly',
    '06': 'totalTaxes',
    '07': 'totalTaxes',
    '08': 'totalOPME',
  };

  totals.totalFees = ((additionalData.proceduresIds?.length > 0) || !(event.multAdditionalData?.length > 1) ?
    (event.procedures.filter(a => additionalData.proceduresIds?.includes(a.rowId)) || []).reduce((accumulator, currentValue) => accumulator + currentValue.value, 0) :
    event.values?.totalProcedures) || 0;

  for (const expense of additionalData.otherExpenses || []) {
    const field = totalValuesToFrom[expense.expenseCode];
    if (!field) { continue; }
    totals[field] += (expense.totalValue || 0);
  }
  let totalValue = 0;
  for (const index in totals) {
    const value = totals[index] || 0;
    totalValue += value;
    additionalData[index] = NumberUtils.currency(value);
  }
  additionalData.total = NumberUtils.currency(totalValue);

  return additionalData;
}
exports.calcTotalExpensesByType = calcTotalExpensesByType;

async function getAuxsIds(eventActors) {
  const auxAnesthetistIds = eventActors?.filter((actor) => actor.type === TeamTypes.KASSISTANT_ANESTHETIST).sort((a, b) => (a.order || 0) - (b.order || 0)).map((actor) => actor.id) || [];
  const auxSurgeonIds = eventActors?.filter((actor) => actor.type === TeamTypes.KASSISTANT_SURGEON).sort((a, b) => (a.order || 0) - (b.order || 0)).map((actor) => actor.id) || [];

  return {
    auxAnesthetistIds,
    auxSurgeonIds
  };
}

exports.getAuxsIds = getAuxsIds;

function calcTotalEvent(event, procedures) {
  event.values.totalProduced = NumberUtils.currency(procedures.totalProcedures + event.values.complementation + event.values.attendanceFee + event.values.expenses);
  event.values.totalReceivedFromOver = NumberUtils.currency(procedures.totalReceivedFromOver);
  event.values.totalReceived = NumberUtils.currency(procedures.totalProceduresReceived + event.values.complementationReceived + event.values.attendanceFeeReceived + event.values.expensesReceived);
  event.values.totalLoss = NumberUtils.currency(procedures.totalProceduresLoss + event.values.complementationLoss /* + event.values.attendanceFeeLoss */ + event.values.expensesLoss);
  event.values.totalDiscount = NumberUtils.currency(procedures.totalDiscount /* + event.values.complementationDiscount */ /* + event.values.attendanceFeeDiscount */ + event.values.expensesDiscount);
  event.values.totalGlosado = NumberUtils.currency(procedures.totalProceduresGlosado /* + event.values.complementationGlosado */ /* + event.values.attendanceFeeGlosado */ + event.values.expensesGlosado);

  event.values.totalChangedPlus = NumberUtils.currency(procedures.totalChangedPlus);
  event.values.totalChangedLess = NumberUtils.currency(procedures.totalChangedLess);
  event.values.totalChanged = NumberUtils.currency(procedures.totalChanged);

  event.values.totalOver = NumberUtils.currency(procedures.totalProceduresOver);
  event.values.totalInProcessing = NumberUtils.currency(procedures.totalInProcessing);

  calcTotalOverOrProcessing(event);
  return event;
}
exports.calcTotalEvent = calcTotalEvent;

function calcTotalOverOrProcessing(event) {
  const overComplementation =  NumberUtils.currency(
    (event.values.complementationReceived + event.values.complementationLoss /* + event.values.complementationDiscount */
    /* + event.values.complementationGlosado */) - event.values.complementation);
  if(overComplementation > 0) { event.values.totalOver = NumberUtils.currency(event.values.totalOver + overComplementation); }
  if(overComplementation < 0) { event.values.totalInProcessing = NumberUtils.currency((event.values.totalInProcessing)+Math.abs(overComplementation)); }

  const overExpenses = NumberUtils.currency(
    (event.values.expensesReceived + event.values.expensesLoss + event.values.expensesDiscount
      + event.values.expensesGlosado) - event.values.expenses);
  if(overExpenses > 0) { event.values.totalOver = NumberUtils.currency(event.values.totalOver + overExpenses); }
  if(overExpenses < 0) { event.values.totalInProcessing = NumberUtils.currency((event.values.totalInProcessing)+Math.abs(overExpenses)); }


  const overAttendanceFee = NumberUtils.currency(
    (event.values.attendanceFeeReceived /* + event.values.attendanceFeeLoss + event.values.attendanceFeeDiscount
      + event.values.attendanceFeeGlosado */) - event.values.attendanceFee);
  if(overAttendanceFee > 0) {
    console.error('Tem coisa errada, não deveria haver over para co-participativo');
    event.values.totalOver = NumberUtils.currency(event.values.totalOver + overAttendanceFee);
  }
  if(overAttendanceFee < 0) { event.values.totalInProcessing = NumberUtils.currency((event.values.totalInProcessing)+Math.abs(overAttendanceFee)); }


  return event;
}
exports.calcTotalOverOrProcessing = calcTotalOverOrProcessing;

function finalizeEventStatus(event) {
  if(event.values.totalInProcessing===0) {
    if(event.values.totalLoss>0 && event.values.totalReceived>0) {
      event.status.status = EventStatus.PartialLosed;
      event.status.received = false;
      event.status.isProcessing = false;
      event.status.isLocked = true;
    }
    else if(event.values.totalLoss>0) {
      event.status.status = EventStatus.Losed;
      event.status.received = false;
      event.status.isProcessing = false;
      event.status.isLocked = true;
    }
    else if(event.values.totalGlosado>0 && event.values.totalReceived>0) {
      event.status.status = EventStatus.PartialCuted;
      event.status.received = false;
      event.status.isProcessing = false;
      event.status.isLocked = true;
    }
    else if(event.values.totalGlosado>0) {
      event.status.status = EventStatus.Cuted;
      event.status.received = false;
      event.status.isProcessing = false;
      event.status.isLocked = true;
    }
    else {
      if ((event.values.totalReceived + (event.values.totalDiscount || 0)) >= 0) {
        event.status.status = EventStatus.Received;
        event.status.received = true;
        event.status.isProcessing = false;
        event.status.isLocked = true;
      }
    }
  } else if(event.healthInsurance && !event.healthInsurance.isParticular) {
    event.values.totalGlosado += event.values.totalInProcessing;
    event.status.status = EventStatus.Cuted;
    event.status.received = false;
    event.status.isProcessing = false;
    event.status.isLocked = true;
  } else {
    event.values.totalLoss += event.values.totalInProcessing;
    event.status.status = EventStatus.Losed;
    event.status.received = false;
    event.status.isProcessing = false;
    event.status.isLocked = true;
  }
}
exports.finalizeEventStatus = finalizeEventStatus;

/**
 * Valida se evento(s) podem ser adicionados ao lote
 * @param {Object} params
 * @param {Object} params.batch - Dados do lote (status, isClosed, countEvents, type, healthInsuranceId)
 * @param {Object|null} params.healthInsurance - Convênio com configs.autoBatchMaxEvents
 * @param {Array} params.events - Eventos a adicionar
 * @returns {{valid: boolean, error?: string, available?: number}}
 */
exports.validateAddToBatch = function({batch, healthInsurance, events}) {
  if (batch?.status === 'CLOSED' || (batch?.isClosed && batch?.status !== 'OPEN')) {
    return {valid: false, error: 'batchSelectedIsClosed'};
  }

  const maxEvents = Number(healthInsurance?.configs?.autoBatchMaxEvents) || 0;
  const currentCount = batch?.countEvents || 0;

  if (maxEvents > 0 && maxEvents < (currentCount + events.length)) {
    const available = Math.max(0, maxEvents - currentCount);
    return {valid: false, error: 'maxEvents', available};
  }

  for (const event of events) {
    if (event.type !== batch.type) {
      return {valid: false, error: 'typeMismatch'};
    }
    if (batch.healthInsuranceId && event.healthInsuranceId !== batch.healthInsuranceId) {
      return {valid: false, error: 'insuranceMismatch'};
    }
  }

  return {valid: true};
};

exports.doAddBatch = async function(event, batch, updateInfo, union=false) {
  startFirebase();
  if(!event.healthInsurance) {
    console.error('doCheckEvent: event.healthInsurance não encontrado', event);
    return null;
  }
  // Resumo, não o documento: a lista de deletes que morava aqui tirava a
  // auditoria e deixava passar competência, convênio, tipo, contadores e
  // marcadores de retroatividade — campos que mudam no lote depois e ficam
  // desatualizados na cópia dentro do evento.
  const tmp = exports.batchResume(batch);

  if(union) {
    await exports.updateEventSimple({
      ...updateInfo,
      id: event.id,
      batchesIds: firebase.firestore.FieldValue.arrayUnion(batch.id),
      batches: firebase.firestore.FieldValue.arrayUnion(tmp),
    });
    return true;
  }
  else {
    await exports.updateEventSimple({
      ...updateInfo,
      id: event.id,
      batchesIds: [batch.id],
      batches: [tmp],
    });
  }
};

exports.doCustomEvent = async function(event, updateInfo) {
  if ([EventStatus.AwaitingCheck, EventStatus.Pending].includes(event.status.status)) {
    event.status.status = EventStatus.Custom;
    event.status.isProcessing = true;
    event.status.isLocked = false;
    const result = await exports.updateEvent(event, updateInfo, true);
    return {result: result, status: 'ok', msg: 'Sucesso'};
  }
  return {result: false, status: 'errorStatus', msg: 'Status inválido para esta operação'};
};

/**
 * Valida campos obrigatórios do evento antes de realizar o check.
 *
 * Realiza validação condicional baseada no tipo de campo configurado:
 * - MANDATORY / MANDATORY_EXTERNAL: Campo obrigatório, valida se está preenchido
 * - VISIBLE: Campo opcional, valida formato apenas se preenchido
 * - NOT_VISIBLE: Campo invisível, ignora completamente a validação
 *
 * @param {Object} event - Evento a ser validado
 * @param {Object} event.healthInsurance - Convênio do evento
 * @param {Object} event.patient - Dados do paciente
 * @param {string} event.accommodation - Acomodação do evento (opcional se configurado como VISIBLE)
 * @param {Object} event.additionalData - Dados adicionais do evento
 * @param {Array} event.attachments - Anexos do evento
 * @returns {Promise<Array>} Array de erros encontrados na validação
 *
 * @example
 * const errors = await validateEventCheck(event);
 * if (errors.length > 0) {
 *   console.info('Erros encontrados:', errors);
 * }
 */
async function validateEventCheck(event) {
  startFirebase();

  if(!event.healthInsurance) {
    console.error('doCheckEvent: event.healthInsurance não encontrado', event);
    return null;
  }

  const mandatoryFieldsId = event?.healthInsurance.eventFieldIds?.check || 'volanEvent';
  const types = {SPSADT: 'spsadt', Honorario: 'fees', Consulta: 'consultation'};
  const mandatoryFields = (await getMandatoryFieldsDoc(mandatoryFieldsId))?.[types[event?.type]];

  if(!mandatoryFields) {
    // Mesmo buraco de validateEventCreate: sem o documento, a primeira leitura
    // de propriedade estourava TypeError em vez de virar erro de validação.
    console.error('validateEventCheck: mandatoryFields não encontrado', {eventId: event?.id, type: event?.type});
    return [{hasError: true, msg: 'Configuração de campos obrigatórios não encontrada', type: 'mandatoryFields'}];
  }

  const validators = [
    status.FieldDisplayType.MANDATORY,
    status.FieldDisplayType.MANDATORY_EXTERNAL
  ];

  const errors = [];

  if(validators.includes(mandatoryFields.patientIdentification?.patient) && !event.patient.name) {
    errors.push({hasError: true, field: 'patient.name', type: 'patientIdentification'});
  }
  if(validators.includes(mandatoryFields.patientIdentification?.insurance) && !event.healthInsurance) {
    errors.push({hasError: true, field: 'healthInsurance', type: 'patientIdentification'});
  }
  if(validators.includes(mandatoryFields.additionalData?.insuranceWallet) && !event.additionalData?.numberWallet) {
    errors.push({hasError: true, field: 'numberWallet', type: 'additionalData'});
  }

  // Verifica se o campo acomodação está configurado para validação
  // Permite que o campo seja configurável: obrigatório, opcional ou invisível
  if(mandatoryFields.patientIdentification?.accommodation) {
    const fieldType = mandatoryFields.patientIdentification.accommodation;
    const isMandatory = fieldType === status.FieldDisplayType.MANDATORY ||
                        fieldType === status.FieldDisplayType.MANDATORY_EXTERNAL;

    // Valida como obrigatório apenas se for MANDATORY ou MANDATORY_EXTERNAL
    if(isMandatory && validators.includes(fieldType) && !event.accommodation) {
      errors.push({hasError: true, msg: 'Acomodação é obrigatória e não foi encontrada'});
    }

    // Se campo é VISIBLE (opcional) e foi preenchido, valida se o valor é válido
    if(fieldType === status.FieldDisplayType.VISIBLE && event.accommodation) {
      const validAccommodations = Object.values(status.Accommodation);
      if(!validAccommodations.includes(event.accommodation)) {
        errors.push({hasError: true, msg: 'Valor de acomodação inválido'});
      }
    }

    // Se campo é NOT_VISIBLE, ignora completamente a validação
  }

  // Collect all errors from various validations
  const sidebarErrors = checkMandatoryFieldsSideBar(validators, mandatoryFields.sideBar, event);
  const attachmentErrors = exports.validateAttachments(event.attachments, mandatoryFields, validators);
  const additionalDataErrors = exports.validateMandatoryAdditionalData(mandatoryFields, event);

  // Combine all errors
  return [
    ...errors,
    ...sidebarErrors,
    ...attachmentErrors,
    ...additionalDataErrors
  ];
}

exports.validateEventCheck = validateEventCheck;

exports.validateAttachments = function(attachments, mandatoryFields, validators) {
  const errors = [];
  const itemsToValidate = Object.keys(mandatoryFields.attachments || {}).filter((mandatoryField) => validators.includes(mandatoryField));

  for (const typeofAttachment of itemsToValidate) {
    if (itemsToValidate[typeofAttachment].length) {
      if (!attachments[typeofAttachment] || (!attachments[typeofAttachment]?.url && !attachments[typeofAttachment]?._tmp?.dataUrl)) {
        errors.push({hasError: true, field: typeofAttachment, type: 'attachments'});
      }
    }
  }

  return errors;
};

exports.validateMandatoryAdditionalData = function(mandatoryFields = {}, event = {}, company = null) {
  const validators = [
    status.FieldDisplayType.MANDATORY,
    status.FieldDisplayType.MANDATORY_EXTERNAL
  ];

  const errors = [];

  if(!event?.multAdditionalData?.length) {
    errors.push({hasError: true, msg: 'Dados adicionais são obrigatórios'});
    return errors;
  }

  for (const item in mandatoryFields?.additionalData) {
    for (const multAdditionalData of event.multAdditionalData) {
      if(validators.includes(mandatoryFields?.additionalData?.[item]) && !multAdditionalData?.[item]) {
        if(company?.flags?.blockEventIfNoNumberGuide && item === 'numberProviderGuide') {
          continue;
        }
        errors.push({hasError: true, field: item, type: 'additionalData'});
      }
    }
  }

  return errors;
};

exports.doCheckEvent = async function(event, updateInfo, additionalProps = {noWrite: false}) {
  if(!event.healthInsurance) {
    console.error('doCheckEvent: event.healthInsurance não encontrado', event);
    return null;
  }

  const validation = await validateEventCheck(event);

  if (validation.some(error => error.hasError)) {
    console.error('Error validation', validation);
    return {
      result: false,
      status: 'validationError',
      msg: 'Erros encontrados na validação do evento',
      errors: validation
    };
  }

  if (event.status.status === EventStatus.AwaitingCheck || event.status.status === EventStatus.WaitRecourse
    || event.status.status === EventStatus.Pending || event.status.status === EventStatus.Custom) {
    if (event.healthInsurance.hasSendGuia && event.status.status !== EventStatus.WaitRecourse) {
      event.status.status = EventStatus.WaitSendGuia;
    } else {
      event.status.status = EventStatus.WaitPayment;
    }
    event.status.isProcessing = true;
    event.status.isLocked = false;
    const form = calculateEventValues(event);
    if(additionalProps.noWrite) {
      return {result: form, status: 'ok', msg: 'Sucesso'};
    } else {
      const result = await exports.updateEvent(form, updateInfo, true);
      return {result: result, status: 'ok', msg: 'Sucesso'};
    }
  } else {
    return {result: false, status: 'errorStatus', msg: 'Status inválido para marcar como conferido'};
  }
};

function checkMandatoryFieldsSideBar(validators, sideBar, event) {
  const mandatoryFieldsArray = [
    { field: 'dtProcedure', validator: sideBar?.procedureDate, message: 'Data do procedimento é obrigatória' },
    { field: 'anesthesiaStart', validator: sideBar?.anesthesiaStart, message: 'Início da anestesia é obrigatório' },
    { field: 'anesthesiaEnd', validator: sideBar?.anesthesiaEnd, message: 'Fim da anestesia é obrigatório' },
    { field: 'procedureStart', validator: sideBar?.procedureStart, message: 'Início do procedimento é obrigatório' },
    { field: 'procedureEnd', validator: sideBar?.procedureEnd, message: 'Fim do procedimento é obrigatório' },
    { field: 'anesthetistId', validator: sideBar?.anesthetist, message: 'Anestesista é obrigatório' },
    { field: 'secondaryAnesthetistId', validator: sideBar?.assistentAnesthetist, message: 'Anestesista assistente é obrigatório' },
    { field: 'residentId', validator: sideBar?.residentAnesthetist, message: 'Residente é obrigatório' },
    { field: 'hospitalId', validator: sideBar?.hospital, message: 'Hospital é obrigatório' }
  ];

  const errors = [];

  for (const { field, validator } of mandatoryFieldsArray) {
    if (validators.includes(validator) && !event[field]) {
      errors.push({ hasError: true, field: field, type: 'sideBar' });
    }
  }

  // Verificação especial para cirurgião/ fono

  const surgeonPhonoMandatory = [
    { field: 'surgeon', validator: sideBar?.surgeon, message: 'Cirurgião é obrigatório' },
    { field: 'phonoaudiologistName', validator: sideBar?.phonoaudiologist, message: 'Fonoaudiólogo é obrigatório' },
  ];

  for (const { field, validator } of surgeonPhonoMandatory) {
    if (validators.includes(validator) && !event.surgeonId && !(event?.actors || []).find(a => a.type === TeamTypes.KPHONOAUDIOLOGIST)) {
      errors.push({ hasError: true, field: field, type: 'sideBar' });
    }
  }

  return errors;
}
exports.checkMandatoryFieldsSideBar = checkMandatoryFieldsSideBar;

exports.doPenddingEvent = async function(event, updateInfo, msg='') {
  startFirebase();
  if(!event.healthInsurance) {
    console.error('doCheckEvent: event.healthInsurance não encontrado', event);
    return null;
  }
  event.status.status = EventStatus.Pending;
  event.status.isLocked = false;
  const form = calculateEventValues(event);
  if(msg) {
    event.observations = firebase.firestore.FieldValue.arrayUnion({
      text: msg,
      date: firebase.firestore.Timestamp.now(),
      userId: updateInfo.meta.updatedBy,
      userName:updateInfo.meta.updatedByName ||'',
      type: status.ObservationType.Pending,
    });
  }
  return await exports.updateEvent(form, updateInfo, false);
};

exports.doInternalPendingEvent = async function(event, updateInfo, msg='') {
  startFirebase();
  if(!event.healthInsurance) {
    console.error('doInternalPendingEvent: event.healthInsurance não encontrado', event);
    return null;
  }
  event.status.status = EventStatus.InternalPending;
  event.status.isLocked = false;
  const form = calculateEventValues(event);
  if(msg) {
    event.observations = firebase.firestore.FieldValue.arrayUnion({
      text: msg,
      date: firebase.firestore.Timestamp.now(),
      userId: updateInfo.meta.updatedBy,
      userName:updateInfo.meta.updatedByName ||'',
      type: status.ObservationType.InternalPending,
    });
  }
  return await exports.updateEvent(form, updateInfo, false);
};

exports.doSendToMatrizOrAwaitingCheckEvents = async function(event, updateInfo) {
  if(!event.healthInsurance) {
    console.error('doSendToMatrizOrAwaitingCheckEvents: event.healthInsurance não encontrado', event);
    return null;
  }
  event.status.status = EventStatus.AwaitingCheck;
  event.status.isLocked = false;
  const form = calculateEventValues(event);
  return await exports.updateEvent(form, updateInfo, true);
};

exports.doSolvePendingEvent = async function(event, updateInfo) {
  if(!event.healthInsurance) {
    console.error('doSolvePendingEvent: event.healthInsurance não encontrado', event);
    return null;
  }
  event.status.status = event.status.status === EventStatus.Pending ? EventStatus.AwaitingCheck : EventStatus.Filled;
  event.status.isLocked = false;
  const form = calculateEventValues(event);
  return await exports.updateEvent(form, updateInfo, true);
};

exports.revertToAwaitCheck = async function(event, updateInfo, msg) {
  startFirebase();
  const oldEvent = _.cloneDeep(event);

  event.status.status = EventStatus.AwaitingCheck;
  event.status.isProcessing = true;
  event.status.isLocked = false;
  event.status.received = false;
  event.active = true;
  delete event.healthInsurance;

  if(msg) {
    const observation = firebase.firestore.FieldValue.arrayUnion({
      text: msg,
      date: firebase.firestore.Timestamp.now(),
      userId: updateInfo.meta.updatedBy,
      userName:updateInfo.meta.updatedByName ||'',
      type: status.ObservationType.RevertStatus,
    });

    event.observations = observation;
    oldEvent.observations = observation;
  }
  exports.clearEvent(event);
  if (oldEvent.id) {
    await firebase.firestore().collection('eventsChanged').add({
      ...event,
      ...updateInfo,
    });
  }

  return await exports.updateEvent(event, updateInfo, false);
};

exports.remove = async function(event, updateInfo, msg) {
  startFirebase();
  const observation = {
    text: msg,
    date: firebase.firestore.Timestamp.now(),
    userId: updateInfo.meta.updatedBy,
    userName:updateInfo.meta.updatedByName ||'',
    type: status.ObservationType.Remove,
  };

  event.observations ||= [];
  // console.log('observation', observation);
  event.observations.push(observation);

  updateInfo.meta.deletedEnv = status.source.WEB;
  updateInfo.meta.deletedBy = updateInfo.meta?.updatedBy;
  updateInfo.meta.deletedAt = firebase.firestore.FieldValue.serverTimestamp();
  event.active = false;
  return await exports.updateEvent(event, updateInfo, true);
};

exports.doSendGuiaForEvent = async function(event, updateInfo) {
  if (event.status.status === EventStatus.AwaitingCheck || event.status.status === EventStatus.Pending
    || event.status.status === EventStatus.WaitSendGuia|| event.status.status === EventStatus.WaitRecourse) {
    event.status.status = EventStatus.WaitPayment;
    event.status.guiaSent = true;
    event.status.isProcessing = true;
    event.status.isLocked = false;
    const result = await exports.updateEvent(event, updateInfo, true);
    return {result: result, status: 'ok', msg: 'Sucesso'};
  }
  return {result: false, status: 'errorStatus', msg: 'Status inválido para enviar a guia'};
};

exports.doSendGuiaForEventBatch = async function(batchId, updateInfo) {
  const progress = {
    ok: [],
    error: [],
    warning: [],
  };
  if(!batchId) {
    return progress;
  }
  const promises = [];
  startFirebase();
  const events = await firebase.firestore().collection('events')
    .where('active', '==', true)
    .where('batchesIds', 'array-contains', batchId)
    .get();
  // console.log('Fcm teste', batchId, events.docs);
  for(const eventObj of events.docs) {
    const event = eventObj.data();
    event.id = eventObj.id;
    if (event.status.status === EventStatus.AwaitingCheck || event.status.status === EventStatus.Pending
    || event.status.status === EventStatus.WaitSendGuia) {
      promises.push(new Promise(async (resolve)=>{
        const ret = await exports.doSendGuiaForEvent(event, updateInfo);
        if(ret) {
          progress.ok.push(event);
        }
        else {
          progress.error.push(event);
        }
        resolve();
      }));
    } else {
      progress.warning.push(event);
    }
  }
  await Promise.all(promises);
  return progress;
};

exports.doFinalizeEvent = async function(event, updateInfo, addTransactions= false, trs = []) {
  if(addTransactions) {
    trs = await exports.getTransactions(event.id);
    fixMissingTransaction(event, trs, {
      userId: 'autoFix',
      userName: 'Auto Fix',
    }, true);
  }

  calculateEventValues(event, true, ActionsOnFinishEvent.LOSS);
  event.status.isLocked = true;
  event.values.totalInProcessing = 0;
  if(addTransactions) {
    fixMissingTransaction(event, trs, {
      userId: updateInfo?.meta?.updatedBy ||'',
      userName: updateInfo?.meta?.updatedByName ||'',
    }, false);
  }

  let result = true;
  // Ter cobranca id, nesse caso, implica que o evento não precisa ser atualizado aqui
  // porque ele será atualizado com os outros lá na cobrança
  if (!event.cobrancaId) { result = await exports.updateEvent(event, updateInfo, true, trs); }
  const response = {
    trs: trs,
    event: event,
    result: result,
    status: 'ok', msg: ''
  };

  delete event.cobrancaId;
  return checkDiffAttendanceFee(event, response);
};

exports.doFinalizeEventNotValued = async function(event, updateInfo) {
  const trs = [];
  event.status.isLocked = true;
  event.values.totalInProcessing = 0;
  if (event.status.status === EventStatus.WaitPayment) {
    event.status.status = EventStatus.Finished;
  }
  return await exports.updateEvent(event, updateInfo, true, trs);
};

/**
 * Resolves the receiver id for a revenueConfig within a procedure group.
 *
 * When the group carries a tab (per-procedure-team flag ON), the resolution
 * walks the tab's own actors first. If the tab has no matching actor, falls
 * back to the event-level actors (legacy `getEventActorIdByType`). When the
 * group has no tab (flag OFF path) resolution is the pre-I08 single-shot
 * behavior via `getEventActorIdByType`.
 *
 * Note: the caller (`doReceiveAllForEvent`) applies an additional
 * `event.anesthetistId` fallback when the resulting `revenueConfigs` array is
 * empty — that outer fallback is not handled here.
 *
 * @param {Object} event - Owning event.
 * @param {{tab: Object|null}} group - Procedure group carrying the resolved tab.
 * @param {string} type - The team type (`TeamTypes.*`).
 * @param {number|null} [order=null] - The actor order when resolving team members.
 * @returns {string|null} The resolved receiver id, or null when none found.
 */
function resolveReceiverIdForGroup(event, group, type, order = null) {
  const tab = group?.tab;
  if (tab && Array.isArray(tab.actors) && tab.actors.length > 0) {
    const tabActor = tab.actors.find((a) => {
      const sameType = a?.type === type;
      const sameOrder = typeof order === 'number' ? a?.order === order : true;
      return sameType && sameOrder;
    });
    if (tabActor?.id) { return tabActor.id; }
  }
  return getEventActorIdByType(event, type, order);
}

/**
 * Builds the procedure groups consumed by `doReceiveAllForEvent`. Each group
 * carries the procedures that belong together for allocation plus the
 * negotiation that must drive their revenueConfigs.
 *
 * When the per-procedure-team flag is OFF, or the event has no usable tabs,
 * returns a single group with every procedure and the event-level negotiation
 * (one `getNegotiation` call). This preserves byte-identical pre-I08 behavior.
 *
 * When the flag is ON and tabs are present, groups procedures by
 * `procedure.procedureTeamId` (unmatched tab ids fall back to the default tab).
 * Each group calls `getNegotiation` once with the tab's effective
 * `dtProcedure` (falls back to `event.dtProcedure` when the tab has no date
 * of its own). Procedures without `procedureTeamId` land in the default tab
 * group. The iteration is O(T), not O(P). Orphan procedures — those with an
 * unmatched `procedureTeamId` and no default tab available — are dropped from
 * the per-tab allocation loop. They are NOT lost: the subsequent
 * `calculateEventValues` + `fixMissingTransaction` calls in
 * `doReceiveAllForEvent` emit reconciliation transactions for them, with the
 * procedure's original (possibly stale) `procedureTeamId` preserved per the
 * procedure-wins stamping policy.
 *
 * @param {Object} event - Event whose procedures we are allocating.
 * @returns {Array<{tab: Object|null, procedures: Array<Object>, negotiation: Object|null}>}
 *   The procedure groups in tab order (default tab first when present).
 */
function buildReceiveAllProcedureGroups(event) {
  const perTabActive = isPerProcedureTeamEnabled(event)
    && Array.isArray(event.procedureTeamTabs)
    && event.procedureTeamTabs.length > 0;

  if (!perTabActive) {
    return [{
      tab: null,
      procedures: Array.isArray(event.procedures) ? [...event.procedures] : [],
      negotiation: exports.getNegotiation(event.dtProcedure, event.healthInsurance),
    }];
  }

  const tabs = event.procedureTeamTabs;
  const defaultTab = tabs.find((t) => t?.isDefault === true) || null;
  const tabsByRowId = new Map();
  for (const tab of tabs) {
    if (tab?.rowId) { tabsByRowId.set(tab.rowId, tab); }
  }

  // Reason: preserving the event.procedureTeamTabs order keeps the allocation
  // loop deterministic for tests and for production. Procedures with a missing
  // or unmatched procedureTeamId land in the default tab group.
  const groups = new Map();
  for (const tab of tabs) {
    groups.set(tab, { tab, procedures: [], negotiation: null });
  }

  for (const proc of event.procedures || []) {
    let owningTab = null;
    if (proc?.procedureTeamId && tabsByRowId.has(proc.procedureTeamId)) {
      owningTab = tabsByRowId.get(proc.procedureTeamId);
    } else {
      owningTab = defaultTab;
    }
    // Reason: Orphan (no matching tab and no default tab). Skipping here
    // excludes the procedure from per-tab allocation; downstream reconciliation
    // (calculateEventValues + fixMissingTransaction) still emits a tx for it
    // with the procedure's own procedureTeamId preserved.
    if (!owningTab) { continue; }
    groups.get(owningTab).procedures.push(proc);
  }

  // Reason (O(T)): resolve the negotiation once per tab AFTER partitioning so
  // we skip empty tabs entirely (no wasted getNegotiation call).
  const result = [];
  for (const group of groups.values()) {
    if (!group.procedures.length) { continue; }
    const tabDt = group.tab.dtProcedure != null ? group.tab.dtProcedure : event.dtProcedure;
    group.negotiation = exports.getNegotiation(tabDt, event.healthInsurance);
    result.push(group);
  }
  return result;
}


/*
 O nome dessa função é receber tudo, mas está errado. Ela recebe o restante,
  não vamos mudar o nome por agora porque pode quebrar o sistema em vários lugares.
 */
exports.doReceiveAllForEvent = async function(event, updateInfo, trs = [], invoice) {
  if (event.status.status === EventStatus.WaitPayment || event.status.status === EventStatus.WaitRecourse
    || event.status.status === EventStatus.Pending) {

    const trsAux = await exports.getTransactions(event.id);
    trs = trs.concat(trsAux || []);
    // console.log('updateInfo', updateInfo);
    // TODO vai funcionar certo em todo lugar que chama essa função e dentro dela está uma cópia da empresa.
    fixMissingTransaction(event, trs, {
      userId: 'autoFix',
      userName: 'Auto Fix',
    }, true);

    const resultFinancialItem = invoice?.id ? await FinancialRepositoryGQL.getTransactionsAggregateByfinancialItemId(invoice.id) : {};
    const totalValueFinancialItem = resultFinancialItem._sum?.value || 0;
    // console.log('totalValueFinancialItem: ', totalValueFinancialItem);

    // Reason (M2-I08, issue #732): group procedures by owning tab when the
    // per-procedure-team flag is ON so each tab resolves its own negotiation
    // (O(T), not O(P)) and allocates from its own actors. When the flag is OFF
    // a single implicit null-tab group preserves byte-identical pre-I08
    // behavior (one getNegotiation call, one pooled revenueConfigs set).
    const procedureGroups = buildReceiveAllProcedureGroups(event);

    let sumAllTransactionsAded = 0;
    const stampPerTab = isPerProcedureTeamEnabled(event);

    for (const group of procedureGroups) {
      if (!group.procedures.length) { continue; }

      const revenueConfigs = [];
      let totalFactor = 0;

      for (const revenue of group.negotiation?.revenueConfigs || []) {
        if (revenue?.enable) {
          const revenueCopy = _.cloneDeep(revenue);
          if (revenue.team?.length) {
            for (const itemTeam of revenue.team) {
              if (itemTeam?.enable && itemTeam?.percentRevenue) {
                const revenueCopy2 = _.cloneDeep(itemTeam);
                revenueCopy2.receiverId = resolveReceiverIdForGroup(event, group, itemTeam.type, itemTeam.order);
                if (revenueCopy2.receiverId) {
                  totalFactor += itemTeam?.percentRevenue;
                  revenueConfigs.push(revenueCopy2);
                }
              }
            }
          } else if (revenue?.percentRevenue) {
            revenueCopy.receiverId = resolveReceiverIdForGroup(event, group, revenueCopy.type);
            if (revenueCopy.receiverId) {
              totalFactor += revenueCopy?.percentRevenue;
              revenueConfigs.push(revenueCopy);
            }
          }
        }
      }

      if (!revenueConfigs.length) {
        totalFactor = 1;
        revenueConfigs.push({
          percentRevenue: 1,
          receiverId: event.anesthetistId || null,
          type: TeamTypes.KANESTHETIST
        });
      }

      for (const proc of group.procedures) {
        proc.totalReceived = NumberUtils.currency(proc.totalReceived || 0);
        proc.totalLoss     = NumberUtils.currency(proc.totalLoss     || 0);
        proc.totalGlosado  = NumberUtils.currency(proc.totalGlosado  || 0);
        proc.totalDiscount = NumberUtils.currency(proc.totalDiscount || 0);
        proc.value         = NumberUtils.currency(proc.value         || 0);

        const resultValue = NumberUtils.currency(proc.value -
          (proc.totalReceived + proc.totalLoss + proc.totalGlosado + proc.totalDiscount));

        if (resultValue > 0) {
          const valueBase = resultValue;
          let overRemain = 0;

          for (const revenue of revenueConfigs) { // distribuição normal sem over
            revenue._remainValue = proc.value * (revenue.percentRevenue / totalFactor);
            revenue._remainValue -= trs.filter(tr => tr.procedureRowId === proc.rowId && tr.receiverId === revenue.receiverId).reduce((previousValue, currentValue) => previousValue + currentValue.value, 0);
            revenue._remainValue = Math.max(revenue._remainValue, 0);

            revenue._value = valueBase * (revenue.percentRevenue / totalFactor);
            if (revenue._value > revenue._remainValue) {
              overRemain += revenue._value - revenue._remainValue;
              revenue._value = revenue._remainValue;
              revenue._remainValue = Math.max(revenue._remainValue - revenue._value, 0);
            }
          }


          if (overRemain>0) {
            let overRemainAll = overRemain;
            for (const revenue of revenueConfigs) { // distribuição normal sem over
              if (revenue._remainValue > 0 && overRemain > 0) {
                let newValue = overRemainAll * (revenue.percentRevenue / totalFactor);
                if (overRemain < newValue) {
                  newValue = overRemain;
                }
                if (revenue._remainValue < newValue) {
                  newValue = revenue._remainValue;
                }
                overRemain -= newValue;
                revenue._value += newValue;
                revenue._remainValue = Math.max(revenue._remainValue - revenue._value, 0);
              }
            }

            if (overRemain > 0) {
              overRemainAll = overRemain;
              for (const revenue of revenueConfigs) { // distribuição sem over mas zerando o remain se disponível
                if (revenue._remainValue > 0 && overRemain > 0) {
                  let newValue = overRemain;
                  if (revenue._remainValue < newValue) {
                    newValue = revenue._remainValue;
                  }
                  overRemain -= newValue;
                  revenue._value += newValue;
                  revenue._remainValue = Math.max(revenue._remainValue - revenue._value, 0);
                }
              }

              if (overRemain > 0) { // distribuição de over
                overRemainAll = overRemain;
                for (const revenue of revenueConfigs) {
                  if (overRemain > 0) {
                    const newValue = overRemainAll * (revenue.percentRevenue / totalFactor);
                    overRemain -= newValue;
                    revenue._value += newValue;
                    revenue._remainValue = Math.max(revenue._remainValue - revenue._value, 0);
                  }
                }
              }
            }
          }

          let sumValue = 0;
          for (const revenue of revenueConfigs) {
            revenue._value = NumberUtils.currency(revenue._value);
            sumValue += revenue._value;
          }
          revenueConfigs[0]._value = NumberUtils.currency(revenueConfigs[0]._value + (valueBase - sumValue));

          for (const revenue of revenueConfigs) {
            const value = revenue._value;
            sumAllTransactionsAded += value;
            const transaction = new TransactionEntity({
              action: BillingActions.Received,
              id: newId(),
              procedureRowId: proc.rowId,
              date: new Date(),
              creationDate: new Date(),
              value: value,
              userId: updateInfo?.meta?.updatedBy ||'',
              userName: updateInfo?.meta?.updatedByName ||'',
              isAdditional: false,
              receiverId: revenue.receiverId,
              receiverType: revenue.type,
              type: TransactionType.PROCEDURE,
              rowIdAdditionalData: proc.rowIdAdditionalData,
              financialItemId: invoice?.id || null,

              eventId: event.id,
              companyId: event.companyId || null,
              matrizId: event.matrizId || null,
              isMatriz: event.isMatriz || false,
              healthInsuranceId: event.healthInsuranceId || null,
              batchesIds: event.batchesIds || null,
              hospitalId: event.hospitalId || null,
              dtProcedure: event.dtProcedure || null,
              cobrancaId: event.cobrancaId || null,
              // Reason (M2-I08, issue #732): stamping is driven by the
              // procedure's procedureTeamId regardless of which tab resolved
              // the receiver. Flag-OFF keeps null for zero-diff parity.
              procedureTeamId: stampPerTab ? (proc.procedureTeamId ?? null) : null,
            });

            trs.push(transaction);

            proc.totalReceived = (proc.totalReceived || 0) + value;
          }
        }
      }
    }

    if (invoice?.id &&
      (NumberUtils.round(invoice?.value) - NumberUtils.round(sumAllTransactionsAded + totalValueFinancialItem))  < 0
    ) {
      return {result: false, status: 'errorValueFinancialItemLessThanSum', msg: 'A soma dos valores ultrapassa o valor disponível da nota'};
    }

    calculateEventValues(event, true, ActionsOnFinishEvent.RECEIVE);

    // TODO vai funcionar certo em todo lugar que chama essa função e dentro dela está uma cópia da empresa.
    fixMissingTransaction({...event, financialItemId: invoice?.id}, trs, {
      userId: updateInfo?.meta?.updatedBy ||'',
      userName: updateInfo?.meta?.updatedByName ||'',
    }, false);

    for (const tr of trs) { await checkCobrancaIdInTransaction(tr); }

    let result = true;
    if (!event.cobrancaId) { result = await exports.updateEvent(event, updateInfo, true, trs); }
    const response = {
      trs: trs,
      event: event,
      result: result,
      status: 'ok', msg: ''
    };
    delete event.cobrancaId;
    return checkDiffAttendanceFee(event, response);
  } else {
    return {result: false, status: 'errorStatus', msg: 'Status inválido para finalizar o evento'};
  }
};

function checkDiffAttendanceFee(event, response) {
  if (!checkDiff(event.values.attendanceFee - event.values.attendanceFeeReceived)) {
    response.status = 'errorAttendanceFee';
    response.msg = 'Realizado partcialmente, não pode ser finalizado com co-participativo em aberto';
  }

  return response;
}


exports.doRecourseSent = async function(event, updateInfo) {
  if(event.status.status === EventStatus.WaitSendRecourse || event.status.status === EventStatus.WaitPayment || event.status.status === EventStatus.WaitSendGuia) {
    // TODO FCM diferente do iOS
    event.status.status = EventStatus.WaitRecourse;
    event.status.recourseSent = true;
    event.status.isProcessing = true;
    event.status.isLocked = false;
    return await exports.updateEvent(event, updateInfo, true);
  } else {
    //nao pode checar pois ja não esta como awaitingCheck
  }
};

exports.doRecourseIndetified = async function(event, updateInfo) {
  if(event.status.status === EventStatus.WaitPayment || event.status.status === EventStatus.Pending) {
    event.status.status = EventStatus.WaitSendRecourse;
    event.status.recourseIdentify = true;
    event.status.isProcessing = true;
    event.status.isLocked = false;
    return await exports.updateEvent(event, updateInfo, true);
  } else {
    //nao pode checar pois ja não esta como awaitingCheck
  }
};

exports.doLossAllForEvent = async function(event, updateInfo, addTransactions=false) {
  if(event.status.status === EventStatus.WaitPayment || event.status.status === EventStatus.WaitRecourse
    || event.status.status === EventStatus.Pending) {
    let trs =[];
    if(addTransactions) {
      trs = await exports.getTransactions(event.id);
      fixMissingTransaction(event, trs, {
        userId: 'autoFix',
        userName: 'Auto Fix',
      }, true);
    }

    calculateEventValues(event, true, ActionsOnFinishEvent.LOSS);

    if(addTransactions) {
      fixMissingTransaction(event, trs, {
        userId: updateInfo?.meta?.updatedBy ||'',
        userName: updateInfo?.meta?.updatedByName ||'',
      }, false);
    }

    const result = await exports.updateEvent(event, updateInfo, true, trs);
    const response = {result: result, status: 'ok', msg: ''};

    checkDiffAttendanceFee(event, response);
    return response;
  } else {
    return {result: false, status: 'errorStatus', msg: 'Status inválido para finalizar o evento'};
  }
};


exports.doGlosaAllForEvent = async function(event, updateInfo, addTransactions=false) {
//        guard let cv = event.convenio else { return }

  if(event.status.status === EventStatus.WaitPayment || event.status.status === EventStatus.WaitRecourse
    || event.status.status === EventStatus.Pending) {
    let trs =[];
    if(addTransactions) {
      trs = await exports.getTransactions(event.id);
      fixMissingTransaction(event, trs, {
        userId: 'autoFix',
        userName: 'Auto Fix',
      }, true);
    }
    calculateEventValues(event, true, ActionsOnFinishEvent.LOSS);

    if(addTransactions) {
      fixMissingTransaction(event, trs, {
        userId: updateInfo?.meta?.updatedBy ||'',
        userName: updateInfo?.meta?.updatedByName ||'',
      }, false);
    }

    const result = await exports.updateEvent(event, updateInfo, true, trs);
    const response = {result: result, status: 'ok', msg: ''};

    checkDiffAttendanceFee(event, response);
    return response;
  } else {
    return {result: false, status: 'errorStatus', msg: 'Status inválido para finalizar o evento'};
  }
};

function reloadProcedure(procedure, newProcedure) {
  procedure.valueTable = newProcedure.valueTable || 0;
  procedure.name = newProcedure.name || procedure.name || '';
  procedure.porteAnestesico = newProcedure.porteAnestesico;
  procedure.porte = newProcedure.porte || '';
  procedure.portePercent = newProcedure.portePercent || 1;
  // `??`, não `||`: a tabela de procedimentos só traz `qtdAux` quando a planilha
  // de origem mapeou a coluna, e `undefined || 0` reescrevia para 0 o -1 que
  // ListModels/EventEntity gravam como default. -1 é "a tabela não define" e 0 é
  // "zero auxiliares" — trocar um pelo outro fazia o verificador acusar diferença
  // em procedimento intacto, e o autoFix "corrigir" evento sem mover nenhum valor.
  procedure.qtdAux = newProcedure.qtdAux ?? procedure.qtdAux ?? -1;
  procedure.uco = newProcedure.uco;
  procedure.tableCode = newProcedure.tableCode || '';
  procedure.type = newProcedure.type;
  // O participative digitado no procedimento (taxa de atendimento) tem precedência; a tabela é só fallback
  procedure.participative = procedure.participative ?? newProcedure.participative ?? 0;
  procedure.valueOriginal = newProcedure.valueOriginal || procedure.valueOriginal || 0;
  if(procedure.porteAnestesico===null || !(procedure.porteAnestesico>=-1)) {
    procedure.porteAnestesico = -1;
  }
  if(procedure.uco===null || procedure.uco===undefined) {
    procedure.uco = -1;
  }
  procedure.id = newProcedure.id || null;
}

/**
 * Reloads and filters procedure values in an event
 *
 * @param {Object} data
 * @param {Object} data.event - The event object containing procedures
 * @param {Array} data.allProcedures - Optional list of all procedures
 * @param {boolean} data.hardFix - Whether to apply hard fixes
 * @param {Object} data.company - The company object
 * @return {Object} Object containing lists of removed and type error procedures
 */
// Adicionar esta função auxiliar antes de reloadProceduresValuesAndFilter
exports.processProcedure = function(procedure, allProcedures, negotiation, hardFix) {
  let newProcedure = null;
  let hasTypeError = false;

  // Determinar o procedimento correto com base no tipo
  switch(procedure.type) {
    case ProcedureType.KCBHPM:
      if(allProcedures) {
        newProcedure = allProcedures.find((a) => a.idProc === procedure.idProc && a.type === procedure.type);
      }
      break;
    case ProcedureType.KOVERRIDEPORTE:
    case ProcedureType.KOVERRIDE:
    case ProcedureType.KOVERRIDEINDICATOR:
      newProcedure = negotiation.overridesProcedures?.find((a) => a.idProc === procedure.idProc);
      break;
    case ProcedureType.KCUSTOM:
      newProcedure = negotiation.customsProcedures?.find((a) => a.id === procedure.id);
      if(!newProcedure) {
        newProcedure = negotiation.customsProcedures?.find((a) => a.idProc === procedure.idProc);
      }
      break;
    case ProcedureType.KPACKAGE:
      newProcedure = negotiation.packages?.find((a) => a.id === procedure.id);
      if(!newProcedure) {
        newProcedure = negotiation.packages?.find((a) => a.idProc === procedure.idProc);
      }
      break;
    case ProcedureType.KVALUEPERHOUR:
      const customProcs = (negotiation.customsProcedures || []).map(proc => proc);
      const cbhpmProcs = (negotiation.proceduresToAddCBHPM || []).map(proc => proc);
      newProcedure =  [...customProcs, ...cbhpmProcs, ...allProcedures].find((a)=>a.idProc===procedure.idProc);
      break;
    default:
      console.trace('Tipo de procedimento desconhecido', procedure);
  }

  // Aplicar hard fix se necessário
  if(!newProcedure && hardFix) {
    hasTypeError = true;

    if(allProcedures) {
      newProcedure = allProcedures.find((a) => a.idProc === procedure.idProc);
    } else {
      newProcedure = negotiation.overridesProcedures?.find((a) => a.idProc === procedure.idProc);
      if(!newProcedure) {
        newProcedure = negotiation.proceduresToAddCBHPM?.find((a) => a.idProc === procedure.idProc);
        if(!newProcedure) {
          newProcedure = negotiation.customsProcedures?.find((a) => a.id === procedure.id);
          if(!newProcedure && procedure.type === ProcedureType.KPACKAGE) {
            newProcedure = negotiation.packages?.find((a) => a.id === procedure.id);
          }
        }
      }
    }
  }

  if(!newProcedure && procedure.type === ProcedureType.KCBHPM) {
    newProcedure = procedure;
  }

  if(newProcedure) {
    // Comparação normalizada. O evento grava o default do modelo (`''`) e a tabela
    // de procedimentos do RTDB não tem o campo quando a planilha de origem não
    // mapeou a coluna — nenhum template do Cbhpm.vue mapeia. `'' !== undefined`
    // marcava typeError em todo procedimento KCBHPM dessas tabelas, e o autoFix não
    // corrigia (o reload devolve `''`), então o mesmo evento voltava a ser reportado
    // a cada rodada do VerifyEvents. Códigos de fato divergentes seguem acusando.
    if((procedure?.tableCode || '') !== (newProcedure?.tableCode || '')) {
      hasTypeError = true;
    }
    reloadProcedure(procedure, newProcedure);
    return { success: true, hasTypeError };
  }

  return { success: false, hasTypeError };
};


/**
 * Reloads and filters procedure values in an event
 *
 * @param {Object} data
 * @param {Object} data.event - The event object containing procedures
 * @param {Array} data.allProcedures - Optional list of all procedures
 * @param {boolean} data.hardFix - Whether to apply hard fixes
 * @param {Object} data.company - The company object
 * @return {Object} Object containing lists of removed and type error procedures
 */
exports.reloadProceduresValuesAndFilter = function(data) {
  const {
    event,
    allProcedures = null,
    hardFix = false,
    company
  } = data;

  const removesIndex = [];
  const typeErrorsIndex = [];
  const negotiation = exports.getNegotiation(event.dtProcedure, event.healthInsurance) || null;

  let participative = 0;
  // Process all procedures
  for(const i in event.procedures || []) {
    const procedure = event.procedures[i];
    // Primeiro processamos o procedimento
    const result = exports.processProcedure(procedure, allProcedures, negotiation, hardFix);
    // Cada parcela arredondada, e só depois somadas — a mesma forma de
    // `setAttendanceFeeValueInProcedure` e `setAttendanceFeeValueFromProcedures`,
    // que é por onde a importação e a tela gravam a taxa.
    //
    // Somar cru e arredondar no fim divergia em um centavo quando o
    // co-participativo do convênio é quebrado, e o rebuild "corrigia" um evento
    // que estava certo. Quem manda aqui é `enableAttendanceFeeReducingFromProcedure`:
    // o participative é descontado do valor da linha e o resultado é arredondado
    // POR LINHA (59,26 − 16,1627… = 43,10), então o co-participativo que de fato
    // existe naquela linha é 59,26 − 43,10 = 16,16. Somar os 16,1627… devolveria
    // um `totalProduced` maior que a soma da tabela — um centavo que o convênio
    // não deve e o paciente não pagou.
    participative += NumberUtils.currency(procedure.participative || 0);
    if(result.success) {
      // Aplicar valor baseado no evento
      exports.setValueProc({
        procedure,
        event,
        negotiation,
        fixValueOriginal: true,
        company
      });

      // Registrar tipo de erro, se houver
      if(result.hasTypeError) {
        typeErrorsIndex.push(Number(i));
      }
    } else {
      // Se não foi possível processar o procedimento principal, marcá-lo para remoção
      removesIndex.push(Number(i));
    }
  }

  // Ainda necessário depois da soma por parcela: somar centavos em ponto
  // flutuante produz cauda binária (16,16 + 16,16 + 25,72 + 25,72 dá
  // 83.75999999999999), e a comparação logo abaixo é de igualdade.
  participative = NumberUtils.currency(participative);
  if (participative!==event.values.attendanceFee && company?.flags?.enableAutomaticAttendanceFee) {
    event.values.attendanceFee = participative;
  }

  // Remover os procedimentos que não puderam ser processados
  const lstRemoved = [];
  const lstTypeError = [];

  for(let i = event.procedures.length - 1; i >= 0; i--) {
    if(removesIndex.includes(i)) {
      lstRemoved.push(event.procedures[i]);
      event.procedures.splice(i, 1);
    } else if(typeErrorsIndex.includes(i)) {
      lstTypeError.push(event.procedures[i]);
    }
  }

  if(lstRemoved.length > 0) {
    // console.log('Removed', lstRemoved);
  }

  return {
    lstRemoved,
    lstTypeError,
  };
};

/**
 *
 * @param that
 * @param event
 * @param force
 * @returns {*}
 *
 * Manter attachResumeToEventForce atualizada com essa
 */
exports.attachResumeToEvent = function(that, event, force=false) {
  if(event.anesthetistId) {
    event.anesthetist ||= {};
    if(!event.anesthetist.name || force) {
      event.anesthetist.name = that.usersKey[event.anesthetistId]?.name || '';
    }
  }
  if(event.secondaryAnesthetistId) {
    event.secondaryAnesthetist ||= {};
    if(!event.secondaryAnesthetist.name || force) {
      event.secondaryAnesthetist.name = that.usersKey[event.secondaryAnesthetistId]?.name || '';
    }
  }
  if(event.thirdAnesthetistId) {
    event.thirdAnesthetist ||= {};
    if(!event.thirdAnesthetist.name || force) {
      event.thirdAnesthetist.name = that.usersKey[event.thirdAnesthetistId]?.name || '';
    }
  }
  if(event.residentId) {
    event.resident ||= {};
    if(!event.resident.name || force) {
      event.resident.name = that.usersKey[event.residentId]?.name || '';
    }
  }
  if(event.hospitalId) {
    event.hospital ||= {};
    if (!event.hospital.name || force) {
      event.hospital.name = that.hospitalsKey[event.hospitalId]?.name || '';
    }
  }
  if(event.surgeonId) {
    event.surgeon ||= {};
    if(!event.surgeon.name || force) {
      event.surgeon.name = that.usersKey[event.surgeonId]?.name || '';
    }
  }
  const phonoaudiologistId = event.actors?.find(a=>a.type===TeamTypes.KPHONOAUDIOLOGIST)?.id;
  if(phonoaudiologistId) {
    event.phonoaudiologist ||= {};
    if(!event.phonoaudiologist.name || force) {
      event.phonoaudiologist.name = that.usersKey[phonoaudiologistId]?.name || '';
    }
  }
  if(event.healthInsuranceId) {
    event.healthInsurance ||= {};
    if (!event.healthInsurance.name || force) {
      const healthInsurance = that.healthInsurancesKey[event.healthInsuranceId] || {};
      event.healthInsurance.name = healthInsurance?.name || '';
      event.healthInsurance.hasSendGuia = healthInsurance?.hasSendGuia || false;
    }
  }

  const requesterActorId = event.actors?.find(a => a.type === TeamTypes.KREQUESTER)?.id;
  if (requesterActorId) {
    event.requester ||= {};
    if (!event.requester.name || force) {
      event.requester.name = that.usersKey[requesterActorId]?.name || '';
    }
  }

  const overrideExecutantActorId = event.actors?.find(a => a.type === TeamTypes.KOVERRIDE_EXECUTANT)?.id;
  if (overrideExecutantActorId) {
    event.overrideExecutant ||= {};
    if (!event.overrideExecutant.name || force) {
      event.overrideExecutant.name = that.usersKey[overrideExecutantActorId]?.name || '';
    }
  }

  return event;
};

/**
 * @param that
 * @param event
 * @returns {*}
 *
 * Manter attachResumeToEvent atualizada com essa
 */
exports.attachResumeToEventForce = function(that, event) {
  event.anesthetist = { name: that.usersKey[event.anesthetistId]?.name || ''};
  event.secondaryAnesthetist = { name: that.usersKey[event.secondaryAnesthetistId]?.name || ''};
  event.thirdAnesthetist = { name: that.usersKey[event.thirdAnesthetistId]?.name || ''};
  event.resident = { name: that.usersKey[event.residentId]?.name || ''};
  event.hospital = { name: that.hospitalsKey[event.hospitalId]?.name || ''};
  event.surgeon = { name: that.usersKey[event.surgeonId]?.name || ''};

  const phonoaudiologistId = event.actors?.find(a=>a.type===TeamTypes.KPHONOAUDIOLOGIST)?.id;
  event.phonoaudiologist = { name: that.usersKey[phonoaudiologistId]?.name || ''};
  const requesterActorId = event.actors?.find(a => a.type === TeamTypes.KREQUESTER)?.id;
  event.requester = { name: that.usersKey[requesterActorId]?.name || ''};
  const overrideExecutantActorId = event.actors?.find(a => a.type === TeamTypes.KOVERRIDE_EXECUTANT)?.id;
  event.overrideExecutant = { name: that.usersKey[overrideExecutantActorId]?.name || ''};

  const healthInsurance = that.healthInsurancesKey[event.healthInsuranceId] || {};
  event.healthInsurance = {
    name: healthInsurance?.name || '',
    hasSendGuia: healthInsurance?.hasSendGuia || false,
  };

  return event;
};


exports.setValuesFormFromProceduresUsedInTransactions = function(form) {

  form = exports.insertExpenseValuesInCorrectAdditionalData(form);
  let values = form.values;
  for (const proc of form.procedures || []) {
    values = exports.setValueFormFromProcTransaction(values, proc);
  }
  form.values = values;

  form.procedures = _.reject(form.procedures, (a) =>
    a.type === TransactionType.EXPENSE ||
    a.type === TransactionType.ATTENDANCEFEE ||
    a.type === TransactionType.COMPLEMENTATION
  );
  return form;
};

exports.setValueFormFromProcTransaction = function(values, proc) {
  switch (proc.type) {
    case TransactionType.ATTENDANCEFEE:
      values = {
        ...values,
        attendanceFee: NumberUtils.currency(proc.totalReceived > 0 ? proc.totalReceived : proc.value),
        attendanceFeeReceived: NumberUtils.currency(proc.totalReceived),
        // attendanceFeeLoss: NumberUtils.currency(proc.totalLoss),
        // attendanceFeeDiscount: NumberUtils.currency(proc.totalDiscount),
        // attendanceFeeGlosado: NumberUtils.currency(proc.totalGlosado),
      };
      break;
    case TransactionType.COMPLEMENTATION:
      values = {
        ...values,
        complementationLoss: NumberUtils.currency(proc.totalLoss),
        complementationReceived: NumberUtils.currency(proc.totalReceived),
        // complementationDiscount: NumberUtils.currency(proc.totalDiscount) + NumberUtils.currency(values.totalDiscount),
        // complementationGlosado: NumberUtils.currency(proc.totalGlosado) + NumberUtils.currency(values.totalGlosado),
      };
      break;
    default:
      break;
  }

  return values;
};

// Isso aqui foi criado para funcionar focado nos lugares onde os valores das taxas/despesas
// são inseridas nos procedimentos para manipulação.
exports.insertExpenseValuesInCorrectAdditionalData = function(form) {
  const expenses = form.procedures.filter(proc => proc.type === TransactionType.EXPENSE) || [];
  if (!expenses.length) { return form;}

  form.multAdditionalData ||= [form.additionalData];

  const multAdditionalData = form.multAdditionalData;
  for (const expense of expenses) {
    const additionalDataIndex = multAdditionalData.findIndex(a => a.rowId === expense.rowIdAdditionalData);
    const additionalData = multAdditionalData[additionalDataIndex] || {};
    const expenseIndex = additionalData.otherExpenses.findIndex(a => a.rowId === expense.rowId);
    if (additionalDataIndex < 0 || expenseIndex < 0 || !additionalData.otherExpenses[expenseIndex]) {
      console.error('Expense not found');
      throw new Error('Expense not found');
    }

    const expenseOriginal = additionalData.otherExpenses[expenseIndex];
    delete expenseOriginal.idProc;
    delete expenseOriginal.name;
    multAdditionalData[additionalDataIndex].otherExpenses[expenseIndex] = {
      ...expenseOriginal,
      totalReceived: NumberUtils.currency(expense.totalReceived),
      totalLoss: NumberUtils.currency(expense.totalLoss),
      totalDiscount: NumberUtils.currency(expense.totalDiscount),
      totalGlosado: NumberUtils.currency(expense.totalGlosado),
    };
  }
  form.multAdditionalData = multAdditionalData;

  return form;
};

function checkIfIsEqual(oldValue, newValue) {
  let isEqual = true;

  function _checkIfIsEqual(oldValue2, newValue2) {
    if (isEqual && typeof oldValue2 === 'object') {
      for (const index in oldValue2) {
        switch (index) {
          case 'meta':
          case 'negotiation':
          case 'company':
          case 'healthInsurance':
            continue;
        }
        _checkIfIsEqual(oldValue2?.[index], newValue2?.[index]);
      }
    } else if (!_.isEqual(oldValue2, newValue2)) {
      isEqual = false;
    }
  }

  _checkIfIsEqual(oldValue, newValue);
  /* Foi adicionado este if porque se houver campos que foram adicionados, não seriam captados como diferentes*/
  if (isEqual) { _checkIfIsEqual(newValue, oldValue); }
  return {isEqual, updatedByName: newValue.meta.updatedByName, updatedAt: newValue.meta.updatedAt, oldValue: newValue, newValue: newValue };
}

exports.checkIfIsEqual = checkIfIsEqual;
exports.separateValuesByActor = separateValuesByActor;
function separateValuesByActor(event, company) {

  let actorTypes;
  /*
    Exceção da exceção que não deveria existir, mas fizemos para resolver o problema da empresa temporariamente,
    porque era uma empresa com mmr alto e havia muito tempo que a demanda da empresa estava aberta.
   */
  if(event.companyId === status.CompanyId.PETROLINA) {
    actorTypes = calculateValuesByActorIfCompanyIsPetrolina(event);
  } else {
    actorTypes = calculateValuesByActor(event, company);
  }

  const valueActorsArray = Object.values(actorTypes).sort((a, b) => {
    if (status.TeamTypesOrder[a.type] === status.TeamTypesOrder[b.type]) {
      return a.order - b.order;
    } else {
      return status.TeamTypesOrder[a.type] - status.TeamTypesOrder[b.type];
    }
  });

  const expense = calculateValuesByOtherExpenses(event);
  expense && valueActorsArray.push(expense);

  if (event.values.complementation > 0) {
    const complementation = {
      id: 'COMPLEMENTATION',
      order: 0,
      type: 'COMPLEMENTATION',
      value: NumberUtils.round(event.values.complementation),
    };
    valueActorsArray.push(complementation);
  }

  if (event.values.attendanceFee > 0) {
    const attendanceFee = {
      id: 'ATTENDANCEFEE',
      order: 0,
      type: 'ATTENDANCEFEE',
      value: NumberUtils.round(event.values.attendanceFee),
    };
    valueActorsArray.push(attendanceFee);
  }

  return valueActorsArray;
}

function calculateValuesByActorIfCompanyIsPetrolina(event) {

  const actorTypes = {};
  const KANESTHETIST = status.TeamTypes.KANESTHETIST;
  const KASSISTANT_ANESTHETIST = status.TeamTypes.KASSISTANT_ANESTHETIST;
  /*
    O cálculo a seguir considera que existem os 3 anestesistas no evento: 1º, 2º e 3º.
    The next calc consider that there are exactly 3 anesthetists in the event: 1º, 2º e 3º.
   */
  const valueThirdAnesthetist = event.values.totalProcedures - NumberUtils.round(2 * (event.values.totalProcedures / 3));

  /*
   O primeiro if é o jeito certo para calcular, somente em cima dos atores. Mas como tem eventos antigos sem os atores
   então fiz o else para resolver por ora.
   The first condition is the correct way to calc, only using the actors. But there are old events without actors, so I made the "else" to solve this for now.
   */
  if (event.actors?.length > 0) {
    const actors = event.actors;
    const anesthetist = actors.find(a => a.type === KANESTHETIST);
    const secondaryAnesthetist = actors.find(a => a.type === KASSISTANT_ANESTHETIST && a.order === 0);
    const thirdAnesthetist = actors.find(a => a.type === KASSISTANT_ANESTHETIST && a.order === 1);

    /*
      Tem terceiro anestesista: 1/3;
      There's third anesthetist: 1/3;

      Não tem terceiro, mas tem o segundo anestesista: 1/2;
      There isn't third anesthetist, but has the first: 1/2;

      Tem somente o primeiro: 1;
      There's only first: 1;
    */
    const multiplierToFirstAnesthetist = thirdAnesthetist ? 1/3 : (secondaryAnesthetist ? 1/2 : 1);

    anesthetist && (actorTypes[KANESTHETIST] = {
      id: anesthetist.id,
      order: 0,
      type: KANESTHETIST,
      value: NumberUtils.round(event.values.totalProcedures * multiplierToFirstAnesthetist),
    });

    secondaryAnesthetist && (actorTypes[KASSISTANT_ANESTHETIST+'_0'] = {
      id: secondaryAnesthetist.id,
      order: 0,
      type: KASSISTANT_ANESTHETIST,
      value: NumberUtils.round(event.values.totalProcedures * multiplierToFirstAnesthetist),
    });

    thirdAnesthetist && (actorTypes[KASSISTANT_ANESTHETIST+'_1'] = {
      id: secondaryAnesthetist.id,
      order: 1,
      type: KASSISTANT_ANESTHETIST,
      value: NumberUtils.round(valueThirdAnesthetist),
    });

  } else {

    /*
      Tem terceiro anestesista: 1/3;
      There's third anesthetist: 1/3;

      Não tem terceiro, mas tem o segundo anestesista: 1/2;
      There isn't third anesthetist, but has the first: 1/2;

      Tem somente o primeiro: 1;
      There's only first: 1;
    */
    const multiplierToFirstAnesthetist = event.thirdAnesthetistId ? 1/3 : (event.secondaryAnesthetistId ? 1/2 : 1);

    actorTypes[KANESTHETIST] = {
      id: event.anesthetistId,
      order: 0,
      type: KANESTHETIST,
      value: NumberUtils.round(event.values.totalProcedures * multiplierToFirstAnesthetist),
    };

    if (event.secondaryAnesthetistId) {
      actorTypes[KASSISTANT_ANESTHETIST+'_0'] = {
        id: event.secondaryAnesthetistId,
        order: 0,
        type: KASSISTANT_ANESTHETIST,
        value: NumberUtils.round(event.values.totalProcedures * multiplierToFirstAnesthetist),
      };
    }

    if (event.thirdAnesthetistId) {
      actorTypes[KASSISTANT_ANESTHETIST+'_1'] = {
        id: event.thirdAnesthetistId,
        order: 1,
        type: KASSISTANT_ANESTHETIST,
        value: NumberUtils.round(valueThirdAnesthetist),
      };
    }
  }

  return actorTypes;
}

function calculateValuesByActor(event, company) {
  const actorTypes = {};
  let actorDefault = status.TeamTypes.KANESTHETIST;

  if (company.billingType === status.CompanyBillingType.MEDICAL) {
    actorDefault = status.TeamTypes.KSURGEON;
    if (event.actors?.find(a=>a.type === status.TeamTypes.KPHONOAUDIOLOGIST && a.id)) {
      actorDefault = status.TeamTypes.KPHONOAUDIOLOGIST;
    }
  }

  for (const proc of event.procedures) {
    if(proc.revenueTeam?.length) {
      for (const revenueActor of proc.revenueTeam) {
        actorTypes[revenueActor.type+'_'+revenueActor.order] ||= {
          id: revenueActor.id,
          order: revenueActor.order || 0,
          type: revenueActor.type,
          value: 0,
        };

        actorTypes[revenueActor.type+'_'+revenueActor.order].value += revenueActor.value;
      }
    } else {
      actorTypes[actorDefault] ||= {
        type: actorDefault,
        value: 0,
      };

      let actor = null;
      if (event.actors?.length) { actor = event.actors.find(a => a.type === actorDefault); }

      if (actor) {
        actorTypes[actorDefault].id = actor.id;
        actorTypes[actorDefault].order = actor.order || 0;
      } else {
        if (actorDefault === status.TeamTypes.KSURGEON) {
          actorTypes[actorDefault].id = event.surgeonId;
        }
        else if (actorDefault === status.TeamTypes.KPHONOAUDIOLOGIST) {
          actorTypes[actorDefault].id = event.actors?.find(a=>a.type === status.TeamTypes.KPHONOAUDIOLOGIST && a.id)?.id || null;
        }
        else { actorTypes[actorDefault].id = event.anesthetistId; }

        actorTypes[actorDefault].order = 0;
      }

      actorTypes[actorDefault].value += proc.value;
    }
  }

  return actorTypes;
}

function calculateValuesByOtherExpenses(event) {
  exports.normalizeMultAdditionalData(event);

  let value = 0;
  for (const additionalData of event.multAdditionalData) {
    if (!additionalData) continue;
    for (const expense of additionalData.otherExpenses || []) {
      value += expense.totalValue || 0;
    }
  }

  if (value === 0) { return null; }

  return {
    id: 'EXPENSE',
    order: 0,
    type: 'EXPENSE',
    value: NumberUtils.round(value),
  };
}

exports.getEventActorIdByType = getEventActorIdByType;

function getEventActorIdByType(event, type, order = null) {
  let id;
  if (event.actors?.length) {
    id = event.actors.find(a => {
      const sameType = a.type === type;
      let sameOrder;
      if(typeof order === 'number') {
        sameOrder = a.order === order;
      } else { sameOrder = true;}

      return sameType && sameOrder;
    })?.id || null;
  } else {
    switch (type) {
      case TeamTypes.KSURGEON:
        id = event.surgeonId;
        break;
      case TeamTypes.KASSISTANT_SURGEON:
        console.error('Se não tá aparecendo aqui, tem coisa errada. Porque os cirurgiões auxiliares foram criados depois dos atores.');
        break;
      case TeamTypes.KRESIDENT_SURGEON:
        console.error('Tem que adicionar o cirurgião residente no sistema');
        break;
      case TeamTypes.KANESTHETIST:
        id = event.anesthetistId;
        break;
      case TeamTypes.KASSISTANT_ANESTHETIST:
        console.error('Se não tá aparecendo aqui, tem coisa errada. Porque os anestesistas auxiliares neste formato foram criados depois dos atores.');
        break;
      /*
      @deprecated
       */
      case TeamTypes.KSECONDARY_ANESTHETIST:
        id = event.secondaryAnesthetistId;
        break;
      case TeamTypes.KRESIDENT_ANESTHETIST:
        id = event.residentId;
        break;
      case TeamTypes.KSCRUB_NURSE:
      case TeamTypes.KNURSE:
        console.error('Tem coisa errada aqui, porque essa função ainda não sabe de onde tira essas inforamções');
        break;
      default:
        console.error('Tem coisa errada aqui!');
        break;
    }
  }

  return id || null;
}

exports.getNewPatient = getNewPatient;

/**
 *
 * @param patientCpf
 * @param patientMomName
 * @param patientName
 * @param patientBirthDate
 * @param email
 * @param addressResult
 * @param companyId
 * @param SET_NULL_ID
 */
function getNewPatient(patientCpf, patientMomName, patientName, patientBirthDate, email, addressResult, companyId, SET_NULL_ID = false) {

  return {
    active: true,
    id: SET_NULL_ID ? null : newId(),
    cpf: patientCpf,
    axregId: null,
    name: patientName + '',
    momName: patientMomName || null,
    nameLowerCase: (patientName + '').toLowerCase().trim(),
    birthDate: patientBirthDate.isValid() ? patientBirthDate.toDate() : null,
    birthDateIso: patientBirthDate.isValid() ? patientBirthDate.format('YYYY-MM-DD') : null,
    gender: null,
    email: email || '',
    address: addressResult || {},
    companyId: companyId || null,
    matrizId: null,
    healthInsuranceId: null,
    healthInsuranceWallet: null,
    accommodation: null,
    phone: null,
    profileImageUrl: null,
    isNew: true,
  };
}


/**
 * Normaliza o campo multAdditionalData de um evento para sempre ser um array
 * Converte o formato antigo (objeto único) para o formato novo (array de objetos)
 * @param {Object} event - Evento a ser normalizado
 * @returns {Object} - O mesmo evento com multAdditionalData normalizado como array
 */
exports.normalizeMultAdditionalData = function(event) {
  if (!event) return event;

  if (Array.isArray(event.multAdditionalData)) {
    return event;
  }

  if (event.additionalData && Object.keys(event.additionalData).length) {
    event.multAdditionalData = [event.additionalData];
  } else {
    event.multAdditionalData = [];
  }
  return event;
};

exports.getNormalizedBillingDateField = function(event, healthInsurance, fieldName) {
  const additionalData = event.additionalData || {};

  if (additionalData[fieldName]) {
    return additionalData[fieldName];
  }

  if (healthInsurance?.flags?.beginEndFaturamentoUseDtProcedure) {
    return event.dtProcedure || null;
  }

  // Regra especial para eventos do tipo Honorário
  if (event.type === status.EventType.Honorario) {
    if (fieldName === 'startDateBilling') {
      return event.anesthesiaStart || null;
    }
    if (fieldName === 'endDateBilling') {
      return event.anesthesiaEnd || null;
    }
  }

  return null;
};

exports.doCreateEvent = async function(event, updateInfo, additionalProps = {noWrite: false}) {
  if(!event.healthInsurance) {
    console.error('doCreateEvent: event.healthInsurance não encontrado', event.healthInsurance);
    return null;
  }

  const validation = await validateEventCreate(event);

  if (validation.some(error => error.hasError)) {
    console.error('Error validation', validation);
    return {
      result: false,
      status: 'validationError',
      msg: 'Erros encontrados na validação do evento',
      errors: validation
    };
  }

  const form = calculateEventValues(event);
  if(additionalProps.noWrite) {
    return {result: form, status: 'ok', msg: 'Sucesso'};
  } else {
    const result = await exports.updateEvent(form, updateInfo, true);
    return {result: result, status: 'ok', msg: 'Sucesso'};
  }
};

async function validateEventCreate(event) {
  startFirebase();

  // _mandatoryFields serve para o chamador entregar a configuração já resolvida
  // e pular a leitura. O campo era testado mas nunca aproveitado: quem o
  // passasse deixava mandatoryFields em null e estourava na primeira leitura de
  // propriedade, algumas linhas abaixo.
  let mandatoryFields = event?._mandatoryFields || null;

  if(!mandatoryFields) {
    const mandatoryFieldsId = event?.healthInsurance?.eventFieldIds?.create || 'volanEvent';
    const types = {SPSADT: 'spsadt', Honorario: 'fees', Consulta: 'consultation'};
    mandatoryFields = (await getMandatoryFieldsDoc(mandatoryFieldsId))?.[types[event?.type]];
  }

  if(!mandatoryFields) {
    // Documento ausente, ou tipo de evento fora do mapa acima. Antes daqui a
    // linha seguinte estourava TypeError, e na importação isso derrubava o
    // Promise.all inteiro: o contador de eventos prontos ficava zerado sem
    // dizer por quê. Vira erro de validação, e o evento para em pendentes.
    console.error('validateEventCreate: mandatoryFields não encontrado', {eventId: event?.id, type: event?.type});
    return [{hasError: true, msg: 'Configuração de campos obrigatórios não encontrada', type: 'mandatoryFields'}];
  }

  const validators = [
    status.FieldDisplayType.MANDATORY,
    status.FieldDisplayType.MANDATORY_EXTERNAL
  ];

  const errors = [];

  if(validators.includes(mandatoryFields.patientIdentification?.patient) && !event.patient.name) {
    errors.push({hasError: true, msg: 'Nome do paciente é obrigatório e não foi encontrado', type: 'patientIdentification'});
  }
  if(validators.includes(mandatoryFields.patientIdentification?.insurance) && !event.healthInsurance) {
    errors.push({hasError: true, msg: 'Convênio é obrigatório e não foi encontrado', type: 'patientIdentification'});
  }
  if(validators.includes(mandatoryFields.additionalData?.insuranceWallet) && !event.additionalData?.numberWallet) {
    errors.push({hasError: true, msg: 'Número da carteira é obrigatório e não foi encontrado', type: 'additionalData'});
  }
  if(validators.includes(mandatoryFields.patientIdentification?.accommodation) && !event.accommodation) {
    errors.push({hasError: true, msg: 'Acomodação é obrigatória e não foi encontrada', type: 'patientIdentification'});
  }

  // Collect all errors from various validations
  const sidebarErrors = checkMandatoryFieldsSideBar(validators, mandatoryFields.sideBar, event);
  const attachmentErrors = exports.validateAttachments(event.attachments, mandatoryFields, validators);
  const additionalDataErrors = exports.validateMandatoryAdditionalData(mandatoryFields, event);
  const customFieldsErrors = exports.validateCustomFields(event, event.healthInsurance);
  const proceduresCountError = event?.procedures?.length === 0 ? [{hasError: true, field: 'procedures', type: 'procedures'}] : [];

  // Combine all errors
  return [
    ...errors,
    ...sidebarErrors,
    ...attachmentErrors,
    ...additionalDataErrors,
    ...customFieldsErrors,
    ...proceduresCountError,
  ];
}

exports.validateEventCreate = validateEventCreate;

exports.validateCustomFields = function(event, healthInsurance) {
  if(!healthInsurance) {
    console.error('Health Insurance not found, please provide to validate custom fields!', healthInsurance);
  }

  const errors = [];

  const mapperCustomFieldResponseType = {
    'select': 'responseOption',
    'text': 'responseText',
    'number': 'responseNumber',
    'date': 'responseDate',
  };

  if (Object.keys(event?.customFields || {}).length) {
    for (const customFieldKey in event.customFields) {
      // Pode ser que no objeto event.customFields nao tenha todas as informacoes necessarias dos custom fields
      const healthInsuranceCustomField = healthInsurance?.customFields?.find(cF => cF.id === customFieldKey);
      const eventCustomField = event?.customFields?.[customFieldKey];

      if (healthInsuranceCustomField?.mandatory) {
        let isFieldValid = true;

        isFieldValid = !!eventCustomField?.[mapperCustomFieldResponseType[healthInsuranceCustomField?.type]];

        if (healthInsuranceCustomField.type === 'checkbox') {
          isFieldValid = !!(
            eventCustomField.responseOptionsIds?.length > 0 ||
            eventCustomField.responseOptions?.length > 0 ||
            eventCustomField.responseOption
          );
        }

        if (!isFieldValid) {
          errors.push({hasError: true, field: healthInsuranceCustomField.name, type: 'customFields'});
        }
      }
    }
  }
  return errors;
};

/**
 *
 * @param {object} context // context from is called
 * @param {object} result // from validate event
 * @returns {string} msg // string message ready to show on screen
 */
exports.getErrorMessagesToShow = function(context, result) {
  // Tratamento especial para erros de validação
  let msg = '';

  if (result?.errors?.length) {
    const fieldNames = result.errors.map(obj => context.$t(`configFields.${obj.type}.${obj.field}`));

    const firstField = fieldNames[0];
    const remainingCount = fieldNames.length - 1;

    if (remainingCount === 0) {
      msg = context.$t('event.errors.missingField', {field: firstField});
    } else {
      msg = context.$t('event.errors.missingFields', {field: firstField, count: remainingCount});
    }
  }

  return msg;
};

/**
 * Retorna valor padrão para campos de additionalData seguindo hierarquia.
 * Preserva valores se forem object ou string (incluindo '').
 *
 * @param {*} currentValue - Valor atual do campo
 * @param {*} fieldsDefaultXML - Padrão do XML
 * @param {*} statusDefaultValue - Padrão do status
 * @param {string} [fallback=''] - Valor final
 * @returns {*} Valor final
 *
 * @example
 * resolveDefaultValue(additionalData.consultType, fieldsXML.consultType, status.defaultInGuide.consultType, '1');
 */
exports.resolveDefaultValue = function(currentValue, fieldsDefaultXML, statusDefaultValue, fallback = '') {
  // Preserva se for objeto ou string (incluindo '' vazio)
  if (typeof currentValue === 'object' || typeof currentValue === 'string') {
    return currentValue;
  }
  return fieldsDefaultXML || statusDefaultValue || fallback;
};

/**
 * Verifica se existe evento ativo vinculado a um número de guia
 * Usa lógica dinâmica para matriz/filial
 *
 * @param {Object} params
 * @param {string} params.numberGuide - Número da guia
 * @param {Object} params.currentCompany - Empresa atual
 * @param {string} params.currentCompanyId - ID da empresa atual
 * @param {Object} [params.healthInsurance] - Convênio (opcional para lógica matriz)
 * @returns {Promise<boolean>} true se evento existe, false caso contrário
 */
exports.checkEventExistsByGuideNumber = async function({ numberGuide, currentCompany, currentCompanyId, healthInsurance }) {
  startFirebase();
  const firestore = firebase.firestore();

  const guide = String(numberGuide).replace(/^0+/, '');
  if (!guide) return false;

  let query = firestore.collection('events')
    .where('additionalData.numberProviderGuide', '==', guide)
    .where('active', '==', true);

  // Lógica baseada em EventEdit.vue (linhas 3772-3784)
  if (healthInsurance && healthInsurance?.isMatriz) {
    // Filial criando para eventos de matriz
    const companyId = currentCompany?.isMatriz ? currentCompanyId : currentCompany?.matrizId;
    query = query
      .where('matrizId', '==', companyId)
      .where('isMatriz', '==', true);
  } else {
    // Empresa comum
    query = query.where('companyId', '==', currentCompanyId);
  }

  const events = await query.limit(1).fcmGet();
  return events.length > 0;
};

// ---------------------------------------------------------------------------
// #739 — Per-procedure (per-tab) public helpers
// ---------------------------------------------------------------------------
//
// The helpers below are the building blocks used by the financial dialogs
// (EditEventValues, EditEventValuesCobranca, FinalizeSelectGlosa) to resolve
// actors / transactions against the procedure's ProcedureTeamTab instead of
// the event-level fields. They all delegate to createProcedureTeamContext so
// flag-OFF behaviour is byte-compatible with the legacy code paths.
// ---------------------------------------------------------------------------

/**
 * Resolves the receiver id for a single (procedure, type [, order]) tuple.
 *
 * Under flag-ON with a tab that has actors, the tab actor wins. Otherwise
 * falls back to `getEventActorIdByType(event, type, order)` — keeping
 * byte-for-byte parity with the legacy call site.
 *
 * @param {Object|null|undefined} event - The event containing flags / actors.
 * @param {Object|null|undefined} procedure - Procedure (may link a tab via `procedureTeamId`).
 * @param {string} type - The TeamTypes value to resolve (e.g. KSURGEON).
 * @param {number|null} [order=null] - Optional actor order to disambiguate duplicates.
 * @returns {string|null} The resolved receiver id, or null when unresolvable.
 */
function resolveReceiverIdForProcedure(event, procedure, type, order = null) {
  if (event == null) {
    return null;
  }

  const ctx = createProcedureTeamContext(event, procedure);

  if (ctx.isTabMode && Array.isArray(ctx.actors) && ctx.actors.length > 0) {
    const match = ctx.actors.find((a) => {
      const sameType = a?.type === type;
      const sameOrder = typeof order === 'number' ? a?.order === order : true;
      return sameType && sameOrder;
    });
    if (match && match.id) {
      return match.id;
    }
  }

  return getEventActorIdByType(event, type, order);
}
exports.resolveReceiverIdForProcedure = resolveReceiverIdForProcedure;

/**
 * Resolves the revenue distribution configuration for a single procedure.
 *
 * Mirrors the inner loop at ~line 2533 of `doReceiveAllForEvent` but scoped
 * to a single procedure so dialog-level callers can reuse the same rules.
 * Each returned entry is a deep clone of the negotiation source so callers
 * may mutate freely without corrupting the negotiation.
 *
 * When the filtered list would be empty (or `negotiation` is missing), the
 * legacy anesthetist fallback `{percentRevenue: 1, receiverId:
 * event?.anesthetistId || null, type: KANESTHETIST}` is returned with
 * `totalFactor = 1`.
 *
 * @param {Object} event - The event.
 * @param {Object} procedure - The procedure being resolved.
 * @param {Object|null|undefined} negotiation - Negotiation whose `revenueConfigs` drive the split.
 * @returns {{revenueConfigs: Array, totalFactor: number}} The resolved configs plus summed factor.
 */
function resolveRevenueConfigsForProcedure(event, procedure, negotiation) {
  const revenueConfigs = [];
  let totalFactor = 0;

  const sourceConfigs = Array.isArray(negotiation?.revenueConfigs)
    ? negotiation.revenueConfigs
    : [];

  for (const revenue of sourceConfigs) {
    if (!revenue?.enable) {
      continue;
    }
    if (Array.isArray(revenue.team) && revenue.team.length) {
      for (const itemTeam of revenue.team) {
        if (itemTeam?.enable && itemTeam?.percentRevenue) {
          const clone = _.cloneDeep(itemTeam);
          clone.receiverId = resolveReceiverIdForProcedure(
            event, procedure, itemTeam.type, itemTeam.order
          );
          if (clone.receiverId) {
            totalFactor += itemTeam.percentRevenue;
            revenueConfigs.push(clone);
          }
        }
      }
    } else if (revenue?.percentRevenue) {
      const clone = _.cloneDeep(revenue);
      clone.receiverId = resolveReceiverIdForProcedure(
        event, procedure, clone.type
      );
      if (clone.receiverId) {
        totalFactor += clone.percentRevenue;
        revenueConfigs.push(clone);
      }
    }
  }

  if (!revenueConfigs.length) {
    return {
      revenueConfigs: [{
        percentRevenue: 1,
        receiverId: event?.anesthetistId || null,
        type: TeamTypes.KANESTHETIST,
      }],
      totalFactor: 1,
    };
  }

  return {revenueConfigs, totalFactor};
}
exports.resolveRevenueConfigsForProcedure = resolveRevenueConfigsForProcedure;

/**
 * Returns the main actor `{id, type}` for a procedure, tab-aware under flag-ON.
 *
 * Under flag-ON with a resolved tab that has actors, the main actor is picked
 * from the tab using the same medical/non-medical rules as
 * `getMainActorInEvent`. If no match is found in the tab (or the tab has no
 * actors), falls back to `getMainActorInEvent(event)`.
 *
 * Under flag-OFF, returns `getMainActorInEvent(event)` verbatim.
 *
 * @param {Object} event - The event.
 * @param {Object} procedure - The procedure whose tab may scope the actor.
 * @returns {{id: (string|null), type: string}} The resolved main actor.
 */
function getMainActorForProcedure(event, procedure) {
  if (event == null) {
    return {id: null, type: null};
  }

  const ctx = createProcedureTeamContext(event, procedure);

  if (ctx.isTabMode && Array.isArray(ctx.actors) && ctx.actors.length > 0) {
    const isMedical = event.company?.billingType === status.CompanyBillingType.MEDICAL;
    let match;
    if (isMedical) {
      match = ctx.actors.find(
        (a) => (a?.type === TeamTypes.KSURGEON || a?.type === TeamTypes.KPHONOAUDIOLOGIST) && a?.id
      );
    } else {
      match = ctx.actors.find((a) => a?.type === TeamTypes.KANESTHETIST);
    }
    if (match && match.id) {
      return {id: match.id, type: match.type};
    }
  }

  return getMainActorInEvent(event);
}
exports.getMainActorForProcedure = getMainActorForProcedure;

// Reason: mirrors the `isNotProcedure` map defined inside the financial
// dialogs. Kept local to the helper so it stays colocated with the only
// caller type-classification logic in EventUtils.
const isNotProcedureForTransaction = {
  [TransactionType.ATTENDANCEFEE]: true,
  [TransactionType.COMPLEMENTATION]: true,
  [TransactionType.EXPENSE]: true,
};

/**
 * Builds a new TransactionEntity for a procedure with tab-aware receiver and
 * `procedureTeamId` stamping.
 *
 * Parity contract with the dialog-level inline helper (pre-refactor):
 *   - `receiverId / receiverType` come from `getMainActorForProcedure`.
 *   - `procedureRowId` is `procedure.rowId` unless `type` is a non-procedure
 *     type other than EXPENSE.
 *   - `rowIdAdditionalData` is set only for EXPENSE (falling back to
 *     `procedure.rowIdAdditionalData` if the caller didn't pass one).
 *   - `type` is `TransactionType.PROCEDURE` unless the caller's `type` is in
 *     the non-procedure set.
 *   - `procedureTeamId` is stamped with `ctx.tabRowId` when the context is in
 *     tab mode (i.e. flag ON + tabs exist) and `null` otherwise.
 *
 * @param {Object} event - The owning event.
 * @param {Object} procedure - The procedure the transaction is tied to.
 * @param {Object} opts - Caller options.
 * @param {string} [opts.id] - Pre-generated transaction id (preferred).
 * @param {Function} [opts.$newId] - Fallback id factory when `id` is absent.
 * @param {Object} [opts.currentUser] - Authenticated user metadata.
 * @param {string} opts.type - Transaction type hint from the dialog.
 * @param {string|null} [opts.procedureRowId] - Explicit override; otherwise derived.
 * @param {string|null} [opts.rowIdAdditionalData] - Override for EXPENSE only.
 * @param {*} [opts.date] - Transaction date; caller owns the Timestamp source
 *   (client dialogs pass a Firestore client Timestamp, server callers pass a
 *   Firestore admin Timestamp). Defaults to a plain Date only when omitted.
 * @param {*} [opts.creationDate] - Creation date; same contract as `date`.
 * @returns {Object} A new TransactionEntity instance.
 */
function createTransactionForProcedure(event, procedure, opts) {
  const EntityCtor = TransactionEntity
    || require('./entities/TransactionEntity').TransactionEntity;
  const {
    id,
    $newId,
    currentUser,
    type,
    procedureRowId,
    rowIdAdditionalData,
    date,
    creationDate,
  } = opts || {};

  const actor = getMainActorForProcedure(event, procedure);
  const ctx = createProcedureTeamContext(event, procedure);

  const resolvedProcedureRowId = (procedureRowId !== undefined)
    ? procedureRowId
    : ((!isNotProcedureForTransaction[type] || type === TransactionType.EXPENSE)
      ? (procedure?.rowId || null)
      : null);

  const resolvedRowIdAdditionalData = (type === TransactionType.EXPENSE)
    ? (rowIdAdditionalData !== undefined
      ? rowIdAdditionalData
      : (procedure?.rowIdAdditionalData || null))
    : null;

  const resolvedDate = date !== undefined ? date : new Date();
  const resolvedCreationDate = creationDate !== undefined ? creationDate : resolvedDate;

  return new EntityCtor({
    id: id || (typeof $newId === 'function' ? $newId() : null),
    procedureRowId: resolvedProcedureRowId,
    rowIdAdditionalData: resolvedRowIdAdditionalData,
    date: resolvedDate,
    creationDate: resolvedCreationDate,
    userId: currentUser?.id || '',
    userName: currentUser?.name || '',
    eventId: event?.id || null,
    companyId: event?.companyId || null,
    matrizId: event?.matrizId || null,
    sMatriz: event?.isMatriz || false,
    healthInsuranceId: event?.healthInsuranceId || null,
    batchesIds: event?.batchesIds || null,
    receiverId: actor?.id || null,
    receiverType: actor?.type || null,
    hospitalId: event?.hospitalId || null,
    dtProcedure: event?.dtProcedure || null,
    type: isNotProcedureForTransaction[type] ? type : TransactionType.PROCEDURE,
    procedureTeamId: ctx.isTabMode ? (ctx.tabRowId || null) : null,
  });
}
exports.createTransactionForProcedure = createTransactionForProcedure;

/**
 * Creates an array of TransactionEntity instances for a procedure, splitting
 * the input `opts.value` proportionally across the procedure's `revenueTeam`
 * (or caller-provided `opts.splits`).
 *
 * Split rule (when `opts.splits` is not provided):
 *   - factor[i] = revenueTeam[i].value / Σ(revenueTeam[j].value where value > 0)
 *   - tx[i].value = NumberUtils.currency(opts.value * factor[i])
 *   - The LAST emitted transaction absorbs the rounding remainder so
 *     Σ(tx[*].value) === NumberUtils.currency(opts.value) exactly.
 *
 * When `opts.splits` is provided, the helper emits one transaction per entry
 * (skipping zero-value splits) and trusts the caller-supplied breakdown
 * verbatim — used by EditEventValues.vue which performs its own overflow /
 * `_remainValue` redistribution before calling this helper.
 *
 * Members with `value <= 0` (or zero-value splits) are skipped — no
 * zero-value transactions are emitted.
 *
 * Falls back to a single transaction with `getMainActorForProcedure` when:
 *   - revenueTeam is missing / empty / all zero, AND
 *   - `opts.splits` is not provided.
 *
 * Universal: applies regardless of the per-procedure-team flag. The
 * per-transaction `procedureTeamId` stamping still goes through
 * `createProcedureTeamContext`, so flag-OFF events get `null` and flag-ON
 * events get the resolved tab rowId.
 *
 * @param {Object} event - The owning event.
 * @param {Object} procedure - The procedure the transactions are tied to.
 * @param {Object} opts - Caller options.
 * @param {string} [opts.id] - Forced id for the single-transaction fallback
 *   path. Ignored when more than one transaction is produced; in that case
 *   `opts.$newId()` MUST be supplied.
 * @param {Function} [opts.$newId] - ID generator. REQUIRED when more than
 *   one transaction is produced.
 * @param {Object} [opts.currentUser] - Authenticated user metadata.
 * @param {string} opts.type - TransactionType (PROCEDURE | EXPENSE |
 *   COMPLEMENTATION | ATTENDANCEFEE) hint from the dialog.
 * @param {string} [opts.action] - BillingActions value to stamp on every
 *   emitted transaction.
 * @param {string|null} [opts.procedureRowId] - Explicit override; otherwise
 *   derived from procedure / type (mirrors createTransactionForProcedure).
 * @param {string|null} [opts.rowIdAdditionalData] - Override for EXPENSE only.
 * @param {number} opts.value - Total amount to split across revenue actors.
 * @param {*} [opts.date] - Transaction date; caller owns the Timestamp source.
 * @param {*} [opts.creationDate] - Creation date; same contract as `date`.
 * @param {boolean} [opts.isAdditional] - Marks the emitted transactions as
 *   complementation-style (forwarded as-is to TransactionEntity).
 * @param {string|null} [opts.cobrancaId] - Cobrança reference, forwarded.
 * @param {string|null} [opts.appealId] - Appeal reference, forwarded.
 * @param {string|null} [opts.financialItemId] - Financial item reference, forwarded.
 * @param {Array<{receiverId: string, receiverType: string, value: number}>} [opts.splits]
 *   Optional caller-provided per-actor breakdown. When present, skips the
 *   automatic split and produces one transaction per non-zero entry.
 * @returns {Array<Object>} Array of TransactionEntity instances. Empty when
 *   `event` is null/undefined.
 */
function createTransactionsForProcedure(event, procedure, opts) {
  if (event == null) {
    return [];
  }

  const EntityCtor = TransactionEntity
    || require('./entities/TransactionEntity').TransactionEntity;
  const {
    id,
    $newId,
    currentUser,
    type,
    action,
    procedureRowId,
    rowIdAdditionalData,
    date,
    creationDate,
    isAdditional,
    cobrancaId,
    appealId,
    financialItemId,
    splits,
    value,
  } = opts || {};

  const ctx = createProcedureTeamContext(event, procedure);

  // Reason: mirrors the resolution rules in createTransactionForProcedure so
  // both helpers produce structurally identical transactions for the same
  // (event, procedure, opts) inputs.
  const resolvedProcedureRowId = (procedureRowId !== undefined)
    ? procedureRowId
    : ((!isNotProcedureForTransaction[type] || type === TransactionType.EXPENSE)
      ? (procedure?.rowId || null)
      : null);

  const resolvedRowIdAdditionalData = (type === TransactionType.EXPENSE)
    ? (rowIdAdditionalData !== undefined
      ? rowIdAdditionalData
      : (procedure?.rowIdAdditionalData || null))
    : null;

  const resolvedDate = date !== undefined ? date : new Date();
  const resolvedCreationDate = creationDate !== undefined ? creationDate : resolvedDate;
  const resolvedType = isNotProcedureForTransaction[type] ? type : TransactionType.PROCEDURE;
  const resolvedProcedureTeamId = ctx.isTabMode ? (ctx.tabRowId || null) : null;

  // Reason: shared payload built once so every emitted transaction inherits
  // the same event/procedure-derived stamping. Per-actor fields (id,
  // receiverId, receiverType, value) are layered on per emission below.
  const baseFields = {
    procedureRowId: resolvedProcedureRowId,
    rowIdAdditionalData: resolvedRowIdAdditionalData,
    date: resolvedDate,
    creationDate: resolvedCreationDate,
    userId: currentUser?.id || '',
    userName: currentUser?.name || '',
    eventId: event?.id || null,
    companyId: event?.companyId || null,
    matrizId: event?.matrizId || null,
    sMatriz: event?.isMatriz || false,
    healthInsuranceId: event?.healthInsuranceId || null,
    batchesIds: event?.batchesIds || null,
    hospitalId: event?.hospitalId || null,
    dtProcedure: event?.dtProcedure || null,
    type: resolvedType,
    procedureTeamId: resolvedProcedureTeamId,
  };
  if (action !== undefined) baseFields.action = action;
  if (isAdditional !== undefined) baseFields.isAdditional = isAdditional;
  if (cobrancaId !== undefined) baseFields.cobrancaId = cobrancaId;
  if (appealId !== undefined) baseFields.appealId = appealId;
  if (financialItemId !== undefined) baseFields.financialItemId = financialItemId;

  const inputValue = NumberUtils.currency(Number(value) || 0);

  // Caller-supplied breakdown wins — used by EditEventValues which already
  // computed per-actor `_value` with overflow redistribution.
  if (Array.isArray(splits) && splits.length > 0) {
    const result = [];
    for (const split of splits) {
      const splitValue = NumberUtils.currency(Number(split?.value) || 0);
      if (!splitValue) continue;
      result.push(new EntityCtor({
        ...baseFields,
        id: typeof $newId === 'function' ? $newId() : (id || null),
        receiverId: split.receiverId || null,
        receiverType: split.receiverType || null,
        value: splitValue,
      }));
    }
    return result;
  }

  // Reason: filter out non-revenue / zero-value team members up-front so the
  // factor sum (and the last-takes-remainder logic) only considers actors
  // that actually receive a slice.
  const eligibleTeam = Array.isArray(procedure?.revenueTeam)
    ? procedure.revenueTeam.filter((m) => m && Number(m.value) > 0)
    : [];

  const totalFactor = eligibleTeam.reduce((acc, m) => acc + Number(m.value), 0);

  // Fallback: no usable revenueTeam → emit one transaction routed to the
  // resolved main actor (legacy single-receiver behaviour).
  if (eligibleTeam.length === 0 || totalFactor <= 0) {
    const actor = getMainActorForProcedure(event, procedure);
    return [new EntityCtor({
      ...baseFields,
      id: id || (typeof $newId === 'function' ? $newId() : null),
      receiverId: actor?.id || null,
      receiverType: actor?.type || null,
      value: inputValue,
    })];
  }

  const result = [];
  let runningSum = 0;
  for (let i = 0; i < eligibleTeam.length; i++) {
    const member = eligibleTeam[i];
    const isLast = i === eligibleTeam.length - 1;
    let share;
    if (isLast) {
      // Reason: last actor absorbs the rounding remainder so the sum of
      // emitted transaction values equals inputValue exactly (currency-safe).
      share = NumberUtils.currency(inputValue - runningSum);
    } else {
      share = NumberUtils.currency(inputValue * (Number(member.value) / totalFactor));
      runningSum = NumberUtils.currency(runningSum + share);
    }
    if (!share) continue;
    result.push(new EntityCtor({
      ...baseFields,
      id: typeof $newId === 'function' ? $newId() : (id || null),
      receiverId: member?.id || null,
      receiverType: member?.type || null,
      value: share,
    }));
  }

  return result;
}
exports.createTransactionsForProcedure = createTransactionsForProcedure;

/**
 * Resolves the actors that should be displayed on a procedure row.
 *
 * Flag ON + tab with actors   → tab actors.
 * Flag ON + tab empty actors  → `event.multAdditionalData` (event-level fallback).
 * Flag OFF                    → `event.multAdditionalData`.
 * Missing event / procedure   → empty array (no throw).
 *
 * @param {Object|null|undefined} event - The event.
 * @param {Object|null|undefined} procedure - The procedure whose tab may scope actors.
 * @returns {Array} The actors to display on the row.
 */
function resolveDisplayActorsForProcedure(event, procedure) {
  if (event == null || procedure == null) {
    return [];
  }

  const ctx = createProcedureTeamContext(event, procedure);

  if (ctx.isTabMode && Array.isArray(ctx.actors) && ctx.actors.length > 0) {
    return ctx.actors;
  }

  return Array.isArray(event.multAdditionalData)
    ? event.multAdditionalData
    : [];
}
exports.resolveDisplayActorsForProcedure = resolveDisplayActorsForProcedure;

// ============== MATCH / NORMALIZAÇÃO ==============

/**
 * Normaliza valor de guia/autorização — trim + remove zeros à esquerda
 * @param {*} value
 * @returns {string}
 */
function normalizeMatchValue(value) {
  return String(value || '').trim().replace(/^0+/, '');
}
exports.normalizeMatchValue = normalizeMatchValue;

/**
 * Verifica se um evento bate com o valor normalizado no campo especificado.
 * Busca em additionalData e multAdditionalData.
 * Sem matchField, busca em todos os campos (fallback genérico).
 * @param {Object} params
 * @param {Object} params.event - Evento com additionalData, multAdditionalData, etc.
 * @param {string} params.normalized - Valor já normalizado pra comparar
 * @param {string} [params.matchField] - Campo de busca. Sem ele busca em tudo.
 * @returns {boolean}
 */
function matchEventByField({ event, normalized, matchField }) {
  const addData = event.additionalData || {};
  const multAdd = event.multAdditionalData || [];

  if (matchField === 'guideNumberSetByOperator') {
    return multAdd.some(a => normalizeMatchValue(a.guideNumberSetByOperator) === normalized)
      || normalizeMatchValue(addData.guideNumberSetByOperator) === normalized;
  }

  if (matchField === 'healthInsuranceWallet') {
    return normalizeMatchValue(event.healthInsuranceWallet) === normalized;
  }

  if (matchField === 'password') {
    return multAdd.some(a => normalizeMatchValue(a.password) === normalized)
      || normalizeMatchValue(addData.password) === normalized;
  }

  if (matchField === 'numberProviderGuide') {
    return (event.numberProviderGuides || []).some(g => normalizeMatchValue(g) === normalized)
      || multAdd.some(a => normalizeMatchValue(a.numberProviderGuide) === normalized)
      || normalizeMatchValue(addData.numberProviderGuide) === normalized;
  }

  // Sem matchField: busca em todos os campos (fallback genérico)
  for (const add of multAdd) {
    if (normalizeMatchValue(add.guideNumberSetByOperator) === normalized) { return true; }
    if (normalizeMatchValue(add.numberProviderGuide) === normalized) { return true; }
    if (normalizeMatchValue(add.password) === normalized) { return true; }
  }
  if (normalizeMatchValue(addData.guideNumberSetByOperator) === normalized) { return true; }
  if (normalizeMatchValue(addData.numberProviderGuide) === normalized) { return true; }
  if (normalizeMatchValue(event.healthInsuranceWallet) === normalized) { return true; }
  if ((event.numberProviderGuides || []).some(g => normalizeMatchValue(g) === normalized)) { return true; }

  return false;
}
exports.matchEventByField = matchEventByField;

